(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9921,5400,3141],{

/***/ 11357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/index.js + 5 modules
var styled_engine = __webpack_require__(23534);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 2 modules
var createTheme = __webpack_require__(17172);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeWithoutDefault.js
var useThemeWithoutDefault = __webpack_require__(34168);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/useTheme.js
'use client';



const systemDefaultTheme = (0,createTheme/* default */.Z)();
function useTheme(defaultTheme = systemDefaultTheme) {
  return (0,useThemeWithoutDefault/* default */.Z)(defaultTheme);
}
/* harmony default export */ var esm_useTheme = (useTheme);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createBox.js
'use client';



const _excluded = ["className", "component"];






function createBox(options = {}) {
  const {
    themeId,
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName
  } = options;
  const BoxRoot = (0,styled_engine["default"])('div', {
    shouldForwardProp: prop => prop !== 'theme' && prop !== 'sx' && prop !== 'as'
  })(styleFunctionSx/* default */.Z);
  const Box = /*#__PURE__*/react.forwardRef(function Box(inProps, ref) {
    const theme = esm_useTheme(defaultTheme);
    const _extendSxProp = (0,extendSxProp/* default */.Z)(inProps),
      {
        className,
        component = 'div'
      } = _extendSxProp,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(_extendSxProp, _excluded);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ref: ref,
      className: (0,clsx/* default */.Z)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box;
}
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(37078);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 14 modules
var styles_createTheme = __webpack_require__(21265);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/identifier.js
var identifier = __webpack_require__(10606);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/boxClasses.js

const boxClasses = (0,generateUtilityClasses/* default */.Z)('MuiBox', ['root']);
/* harmony default export */ var Box_boxClasses = (boxClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/Box.js
'use client';







const defaultTheme = (0,styles_createTheme/* default */.Z)();
const Box = createBox({
  themeId: identifier/* default */.Z,
  defaultTheme,
  defaultClassName: Box_boxClasses.root,
  generateClassName: ClassNameGenerator/* default.generate */.Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 34168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87685);
'use client';



function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
  const contextTheme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__.T);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 47893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */
function useCommittedRef(value) {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
/* harmony default export */ __webpack_exports__["Z"] = (useCommittedRef);

/***/ }),

/***/ 67177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useCommittedRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47893);


function useEventCallback(fn) {
  const ref = (0,_useCommittedRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(fn);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}

/***/ }),

/***/ 19085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const isReactNative = typeof __webpack_require__.g !== 'undefined' &&
// @ts-ignore
__webpack_require__.g.navigator &&
// @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
const isDOM = typeof document !== 'undefined';

/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */
/* harmony default export */ __webpack_exports__["Z"] = (isDOM || isReactNative ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect);

/***/ }),

/***/ 61218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */
function useMounted() {
  const mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
  const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(() => mounted.current);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}

/***/ }),

/***/ 69802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePrevious; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Store the last of some value. Tracked via a `Ref` only updating it
 * after the component renders.
 *
 * Helpful if you need to compare a prop value to it's previous value during render.
 *
 * ```ts
 * function Component(props) {
 *   const lastProps = usePrevious(props)
 *
 *   if (lastProps.foo !== props.foo)
 *     resetValueFromProps(props.foo)
 * }
 * ```
 *
 * @param value the value to track
 */
function usePrevious(value) {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
}

/***/ }),

/***/ 2620:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/minus.c418c5f2.svg","height":20,"width":20});

/***/ }),

/***/ 70095:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/phone-incoming-01.2cdd60c3.svg","height":28,"width":28});

/***/ }),

/***/ 25797:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/play-icon.c3a025c1.svg","height":57,"width":50});

/***/ }),

/***/ 41611:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/plus.3dbcf26a.svg","height":20,"width":20});

/***/ }),

/***/ 65732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ size_help; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./public/images/icons/info-circle.svg
/* harmony default export */ var info_circle = ({"src":"/_next/static/media/info-circle.a1df93aa.svg","height":24,"width":24});
// EXTERNAL MODULE: ./src/components/buttons/size-help/style.module.scss
var style_module = __webpack_require__(63581);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/buttons/size-help/index.tsx






var SizeCardModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5854).then(__webpack_require__.bind(__webpack_require__, 5854));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5854)
            ];
        }
    }
});
var SizeHelpButton = function() {
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (style_module_default()).sizeHelpBtnContainer,
                onClick: function() {
                    return setShowModal(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: info_circle.src,
                        alt: "info-icon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "Size Help"
                        })
                    })
                ]
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeCardModal, {
                open: showModal,
                onClose: function() {
                    setShowModal(false);
                }
            })
        ]
    });
};
/* harmony default export */ var size_help = (SizeHelpButton);


/***/ }),

/***/ 19399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44012);
/* harmony import */ var _public_images_icons_chevron_down_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78868);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66287);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var PromotionDropdown = function(props) {
    var unit = props.unit, onSelect = props.onSelect, promotionError = props.promotionError, locale = props.locale, isMultiPromo = props.isMultiPromo;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedPromotion = ref1[0], setSelectedPromotion = ref1[1];
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var promotionList = unit.promotionList;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setSelectedPromotion(promotionList[0]);
        onSelect(promotionList[0]);
    }, [
        unit
    ]);
    var toggleDropdown = function() {
        setIsOpen(!isOpen);
    };
    var handleClickOutside = function(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };
    var handlePromotionClick = function(promotion) {
        setSelectedPromotion(promotion);
        setIsOpen(false);
        onSelect(promotion);
    };
    var badgeId = function(promotion) {
        if (locale === "fr") return promotion === null || promotion === void 0 ? void 0 : promotion.badgeFr;
        if (locale === "en") return promotion === null || promotion === void 0 ? void 0 : promotion.badgeEn;
        return null;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().promotionDropdown),
        ref: dropdownRef,
        children: [
            promotionError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().errorText),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    id: "pleaseApplyPromotion"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: isOpen ? "".concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().applyPromotionOpen), " ").concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().applyPromotion), " ").concat(selectedPromotion ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().selected) : "") : "".concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().applyPromotion), " ").concat(selectedPromotion ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().selected) : "", " ").concat(promotionError ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().promotionError) : ""),
                onClick: toggleDropdown,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().applyPromotionTextContainer),
                        children: selectedPromotion ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().selectedPromotion),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.badgeEn) && isMultiPromo === true ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().applyPromotionText) : (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().applyPromotionTextFull),
                                    children: locale === "en" ? selectedPromotion.en : selectedPromotion.fr
                                }),
                                (selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.badgeEn) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "".concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().tag), " ").concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().promotionAnimation)),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        id: badgeId(selectedPromotion)
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noPromotionText),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                id: "applyPromotion"
                            })
                        })
                    }),
                    promotionList.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: _public_images_icons_chevron_down_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                            alt: "chevron-down"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: isOpen ? "".concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().dropdownContent), " ").concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().open)) : (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().dropdownContent),
                style: {
                    maxHeight: isOpen ? "".concat(promotionList.length * 48, "px") : "0px"
                },
                children: promotionList.map(function(promotion, key) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().promotionOption),
                        onClick: function() {
                            return handlePromotionClick(promotion);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().promotionText),
                                children: locale === "en" ? promotion.en : promotion.fr
                            }),
                            (promotion === null || promotion === void 0 ? void 0 : promotion.badgeEn) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().tag),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    id: badgeId(promotion)
                                })
                            })
                        ]
                    }, key);
                })
            }),
            promotionError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().secondaryErrorText), " ").concat(isOpen ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().secondaryErrorTextNone) : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    id: "pleaseApplyPromotion"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PromotionDropdown);


/***/ }),

/***/ 25400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ overall_rating; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./public/images/icons/google-icon.svg
/* harmony default export */ var google_icon = ({"src":"/_next/static/media/google-icon.ea51245c.svg","height":45,"width":45});
// EXTERNAL MODULE: ./src/components/home-content/home.module.scss
var home_module = __webpack_require__(59343);
var home_module_default = /*#__PURE__*/__webpack_require__.n(home_module);
;// CONCATENATED MODULE: ./src/components/home-content/overall-rating.tsx





var OverallRating = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "overall-ratings",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex align-items-center justify-content-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (home_module_default()).overallratings,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "rated-reviews"
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: props === null || props === void 0 ? void 0 : props.rating
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "out-of"
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            " ",
                                            props === null || props === void 0 ? void 0 : props.numberOfReviews,
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "reviews-of"
                                            })
                                        ]
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "reviews-on"
                                    }),
                                    " "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: google_icon,
                                alt: "google",
                                height: "30px",
                                width: "30px"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var overall_rating = (OverallRating);


/***/ }),

/***/ 63141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stars__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88803);


var Reviews = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var dataFull = props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : (ref1 = ref.date) === null || ref1 === void 0 ? void 0 : ref1.split("T")[0];
    var date = new Date(dataFull);
    date.setDate(date.getDate() + 1);
    var day = date === null || date === void 0 ? void 0 : date.getDate();
    var year = date === null || date === void 0 ? void 0 : date.getFullYear();
    var month = date === null || date === void 0 ? void 0 : date.toLocaleString("default", {
        month: "long"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "col-xl-4 col-lg-4 col-md-6 col-sm-12",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "card sv-review-card sv-card-equal-height",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-body",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                        className: "customer-name",
                        children: props === null || props === void 0 ? void 0 : (ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "date d-flex align-items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_stars__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                data: props === null || props === void 0 ? void 0 : (ref3 = props.data) === null || ref3 === void 0 ? void 0 : ref3.rating
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-1",
                                children: [
                                    day,
                                    " ",
                                    month,
                                    " ",
                                    year
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "para",
                        children: [
                            props === null || props === void 0 ? void 0 : (ref4 = props.data) === null || ref4 === void 0 ? void 0 : ref4.text,
                            " "
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Reviews);


/***/ }),

/***/ 88803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_simple_star_rating__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13773);


var StarsComponent = function(props) {
    var ratin = props === null || props === void 0 ? void 0 : props.data;
    var rate = ratin || 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "rating-stars d-flex align-items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_star_rating__WEBPACK_IMPORTED_MODULE_1__/* .Rating */ .i, {
                initialValue: rate,
                readonly: true,
                size: 18,
                allowFraction: true
            }),
            (props === null || props === void 0 ? void 0 : props.toggleText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "sv-dark-grey-bold-para text-black mb-0 ms-2 mt-1",
                children: rate
            })
        ]
    }, Math.random());
};
/* harmony default export */ __webpack_exports__["Z"] = (StarsComponent);


/***/ }),

/***/ 59100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44012);
/* harmony import */ var _home_content_overall_rating__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25400);
/* harmony import */ var _home_content_reviews__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63141);





var ClientReviews = function(props) {
    var ratingData = props.ratingData;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), reviewsAll = ref[0], setReviewsAll = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), rating = ref1[0], setRating = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), numberOfReviews = ref2[0], setNumberOfReviews = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setReviewsAll(ratingData === null || ratingData === void 0 ? void 0 : ratingData.highlightedReviews);
        setRating(ratingData === null || ratingData === void 0 ? void 0 : ratingData.averageRating);
        setNumberOfReviews(ratingData === null || ratingData === void 0 ? void 0 : ratingData.numberOfReviews);
    }, [
        ratingData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: reviewsAll && (reviewsAll === null || reviewsAll === void 0 ? void 0 : reviewsAll.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            id: "client-reviews-google",
            className: "reviews",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "section-heading",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            id: "client-reviews"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "review-cards d-none d-lg-block d-md-none",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row justify-content-center g-3",
                            children: reviewsAll === null || reviewsAll === void 0 ? void 0 : reviewsAll.map(function(data, index) {
                                return index < 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_content_reviews__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    data: data
                                }, data === null || data === void 0 ? void 0 : data.name);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "review-cards d-none d-lg-none d-md-block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row justify-content-center g-3",
                            children: reviewsAll === null || reviewsAll === void 0 ? void 0 : reviewsAll.map(function(data, index) {
                                return index < 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_content_reviews__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    data: data
                                }, data === null || data === void 0 ? void 0 : data.name);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "review-cards d-block d-lg-none d-md-none",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row justify-content-center g-3",
                            children: reviewsAll === null || reviewsAll === void 0 ? void 0 : reviewsAll.map(function(data, index) {
                                return index === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_content_reviews__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    data: data
                                }, data === null || data === void 0 ? void 0 : data.name);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_home_content_overall_rating__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        rating: rating,
                        numberOfReviews: numberOfReviews
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ClientReviews);


/***/ }),

/***/ 39593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store_locator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
// EXTERNAL MODULE: ./src/context/StoreDataContext.tsx
var StoreDataContext = __webpack_require__(60958);
;// CONCATENATED MODULE: ./src/utils/useBreakPoints.ts

var useBreakPoints = function() {
    var ref = (0,react.useState)(false), isDesktop = ref[0], setDesktop = ref[1];
    var breakPoint;
    var updateMedia = function() {
        breakPoint = window.innerWidth >= 992;
        setDesktop(breakPoint);
    };
    (0,react.useEffect)(function() {
        updateMedia();
        window.addEventListener("resize", updateMedia);
        return function() {
            window.removeEventListener("resize", updateMedia);
        };
    });
    return isDesktop;
};

;// CONCATENATED MODULE: ./src/components/store-locator/index.tsx






var FilterLocator = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1608), __webpack_require__.e(2223), __webpack_require__.e(3752), __webpack_require__.e(8738), __webpack_require__.e(5961)]).then(__webpack_require__.bind(__webpack_require__, 65961));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65961)
            ];
        }
    }
});
var MapComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1255), __webpack_require__.e(1608), __webpack_require__.e(1664), __webpack_require__.e(4585), __webpack_require__.e(8837), __webpack_require__.e(1909), __webpack_require__.e(2223), __webpack_require__.e(3752), __webpack_require__.e(5398), __webpack_require__.e(8738), __webpack_require__.e(7546), __webpack_require__.e(6311), __webpack_require__.e(7274)]).then(__webpack_require__.bind(__webpack_require__, 84929));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84929)
            ];
        }
    }
});
var SearchLocator = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1255), __webpack_require__.e(1608), __webpack_require__.e(4585), __webpack_require__.e(8837), __webpack_require__.e(1909), __webpack_require__.e(7546), __webpack_require__.e(4745)]).then(__webpack_require__.bind(__webpack_require__, 44943));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44943)
            ];
        }
    }
});
var LocationListWithOrderBy = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1608), __webpack_require__.e(1664), __webpack_require__.e(2223), __webpack_require__.e(3752), __webpack_require__.e(5398), __webpack_require__.e(8738), __webpack_require__.e(6311), __webpack_require__.e(5018)]).then(__webpack_require__.bind(__webpack_require__, 25018));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25018)
            ];
        }
    }
});
var StoreLocatorComponent = function(props) {
    var ref, ref1, ref2;
    // tablet mobile change key
    var ref3 = (0,react.useState)(false), expandMap = ref3[0], setExpandmap = ref3[1];
    var ref4 = (0,react.useState)(false), showList = ref4[0], setShowList = ref4[1]; // toggle Store Locator page view between locations and map on tablet and mobile screen (true: locations, false: map)
    var applyFilter = (0,react.useContext)(StoreDataContext/* default */.ZP);
    var storeData = (0,react.useContext)(StoreDataContext/* default */.ZP);
    var locations = applyFilter.applyFilters;
    var values = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var isDesktop = useBreakPoints();
    var ref5 = (0,react.useState)(props === null || props === void 0 ? void 0 : (ref = props.preFilter) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.Filter), preFilterData = ref5[0], setPreFilterData = ref5[1];
    var keys = {
        driveup: false,
        heated: false,
        climateControlled: false,
        small: false,
        medium: false,
        large: false,
        xlarge: false,
        carstorage: false,
        parking: false
    };
    var handleExpand = function(expand) {
        setExpandmap(expand);
    };
    var setAndresetpreFilters = function(value) {
        var ref;
        if ((props === null || props === void 0 ? void 0 : (ref = props.preFilter) === null || ref === void 0 ? void 0 : ref.data) !== null && (props === null || props === void 0 ? void 0 : props.vehicle)) {
            if (preFilterData === "Car Storage") {
                keys.carstorage = value;
                storeData.setFilterData(keys);
            } else if (preFilterData === "Drive-up") {
                keys.driveup = value;
                storeData.setFilterData(keys);
            } else if (preFilterData === "Heated") {
                keys.heated = value;
                storeData.setFilterData(keys);
            } else if (preFilterData === "Outdoor Parking") {
                keys.parking = value;
                storeData.setFilterData(keys);
            } else if (preFilterData === "Climate Controlled") {
                keys.climateControlled = value;
                storeData.setFilterData(keys);
            }
        }
    };
    (0,react.useEffect)(function() {
        values === null || values === void 0 ? void 0 : values.setShowFooter(false);
        setShowList(false);
        setAndresetpreFilters(true);
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.facilityc) === null || ref === void 0 ? void 0 : ref.length) {
            var slug = props === null || props === void 0 ? void 0 : props.cityLanding;
            var quickSearchData = storeData && storeData.facilityc && storeData.facilityc.find(function(item) {
                return item.city === slug;
            });
            storeData.setquickSearchInfo(quickSearchData);
        }
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.resetpreFilters) && preFilterData) {
            Object.assign(keys, storeData === null || storeData === void 0 ? void 0 : storeData.filterData);
            setPreFilterData("");
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.storeData,
        storeData === null || storeData === void 0 ? void 0 : storeData.facilityc
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "self-storage",
            className: (values === null || values === void 0 ? void 0 : values.isShowSelfHeader) ? "find-storage-wrapper no-units-found-wrapper sv-page-content" : "find-storage-wrapper no-units-found-wrapper sv-page-content pt-0 mt-0 fullview-map",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: expandMap ? "custom-section" : "container custom-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "sv-find-storage-web",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row g-0",
                        children: [
                            isDesktop && !expandMap && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-7",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sv-find-storage-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchLocator, {
                                            cityTitle: props === null || props === void 0 ? void 0 : props.cityTitle,
                                            vehicle: props === null || props === void 0 ? void 0 : props.vehicleLandingPage
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLocator, {
                                            expandMap: expandMap,
                                            cityLanding: props.cityLanding
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(expandMap ? "col-lg-12 fullScreen-map" : "col-lg-5", " col-md-12 col-12"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (values === null || values === void 0 ? void 0 : values.isShowSelfHeader) ? "view-units-map" : "view-units-map pt-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tab-view-search-section d-block d-lg-none",
                                            children: !(isDesktop && !expandMap) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: (values === null || values === void 0 ? void 0 : values.isShowSelfHeader) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchLocator, {
                                                            cityTitle: props.cityTitle,
                                                            vehicle: props === null || props === void 0 ? void 0 : props.vehicleLandingPage
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "container px-custom",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "sv-multi-select-tabs mb-2",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLocator, {
                                                                    expandMap: expandMap,
                                                                    cityLanding: props.cityLanding
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }) : null
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MapComponent, {
                                            locations: locations,
                                            handleExpand: handleExpand,
                                            cityLanding: props.cityLanding,
                                            toggleShow: function() {
                                                setShowList(!showList);
                                            },
                                            showList: showList
                                        }),
                                        !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationListWithOrderBy, {
                                            locations: locations,
                                            toggleShow: function() {
                                                return setShowList(!showList);
                                            },
                                            showList: showList
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var store_locator = (StoreLocatorComponent);


/***/ }),

/***/ 15931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 3 modules
var Box = __webpack_require__(11357);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js + 1 modules
var DefaultPropsProvider = __webpack_require__(85845);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 1 modules
var styled = __webpack_require__(70736);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CircularProgress/circularProgressClasses.js


function getCircularProgressUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCircularProgress', slot);
}
const circularProgressClasses = (0,generateUtilityClasses/* default */.Z)('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);
/* harmony default export */ var CircularProgress_circularProgressClasses = ((/* unused pure expression or super */ null && (circularProgressClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
'use client';



const _excluded = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;











const SIZE = 44;
const circularRotateKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const circularDashKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    color,
    disableShrink
  } = ownerState;
  const slots = {
    root: ['root', variant, `color${(0,capitalize/* default */.Z)(color)}`],
    svg: ['svg'],
    circle: ['circle', `circle${(0,capitalize/* default */.Z)(variant)}`, disableShrink && 'circleDisableShrink']
  };
  return (0,composeClasses/* default */.Z)(slots, getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'inline-block'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('transform')
}, ownerState.color !== 'inherit' && {
  color: (theme.vars || theme).palette[ownerState.color].main
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && (0,emotion_react_browser_esm/* css */.iv)(_t3 || (_t3 = _`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe));
const CircularProgressSVG = (0,styled/* default */.ZP)('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: (props, styles) => styles.svg
})({
  display: 'block' // Keeps the progress centered
});
const CircularProgressCircle = (0,styled/* default */.ZP)('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.circle, styles[`circle${(0,capitalize/* default */.Z)(ownerState.variant)}`], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  stroke: 'currentColor'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('stroke-dashoffset')
}, ownerState.variant === 'indeterminate' && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const CircularProgress = /*#__PURE__*/react.forwardRef(function CircularProgress(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiCircularProgress'
  });
  const {
      className,
      color = 'primary',
      disableShrink = false,
      size = 40,
      style,
      thickness = 3.6,
      value = 0,
      variant = 'indeterminate'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    disableShrink,
    size,
    thickness,
    value,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};
  if (variant === 'determinate') {
    const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = 'rotate(-90deg)';
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    style: (0,esm_extends/* default */.Z)({
      width: size,
      height: size
    }, rootStyle, style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CircularProgress_CircularProgress = (CircularProgress);
;// CONCATENATED MODULE: ./src/components/store-locator/loading.tsx



var Loading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            display: "flex",
            width: "100vw",
            py: "100px",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress_CircularProgress, {
            color: "primary"
        })
    });
};
/* harmony default export */ var loading = (Loading);


/***/ }),

/***/ 24077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ location_landing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
// EXTERNAL MODULE: ./src/context/MapCordinateContext.tsx
var MapCordinateContext = __webpack_require__(20546);
// EXTERNAL MODULE: ./src/components/store-locator/index.tsx + 1 modules
var store_locator = __webpack_require__(39593);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./src/components/store-locator/about-page.tsx


var AboutPage = function(props) {
    var ref, ref1;
    var facilityData = props.facilityData;
    var aboutTitle = facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : ref.About_Title;
    var description = facilityData === null || facilityData === void 0 ? void 0 : (ref1 = facilityData.attributes) === null || ref1 === void 0 ? void 0 : ref1.About_Facility;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "sv-about-access-storage",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    aboutTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "section-heading",
                        children: aboutTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(description)
                                }
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var about_page = (AboutPage);

// EXTERNAL MODULE: ./src/components/store-locator/client-review.tsx
var client_review = __webpack_require__(59100);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./src/components/store-locator/community-involvement.tsx




var CommunityInvolvement = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var blogData = props.blogData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "sv-community-involvement",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "section-heading",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "community-involvement"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center justify-content-center gx-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    sizes: "(max-width: 375px) 295px, (max-width: 576px) 290px, (max-width: 768px) 350px, (max-width: 992px) 470px, (max-width: 1280px) 550px",
                                    src: blogData === null || blogData === void 0 ? void 0 : (ref = blogData.Thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url,
                                    className: "card-img-top community-img",
                                    alt: (blogData === null || blogData === void 0 ? void 0 : (ref3 = blogData.Thumbnail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.alternativeText) || (blogData === null || blogData === void 0 ? void 0 : (ref6 = blogData.Thumbnail) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.attributes) === null || ref8 === void 0 ? void 0 : ref8.name),
                                    width: "370",
                                    height: "300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-lg-6 col-md-6 col-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: blogData === null || blogData === void 0 ? void 0 : blogData.Title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "card-content",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(blogData === null || blogData === void 0 ? void 0 : blogData.Excerpt)
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var community_involvement = (CommunityInvolvement);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/helper/wordReplace.tsx
var wordReplace = __webpack_require__(27147);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/nuka-carousel/es/index.js
var es = __webpack_require__(33752);
var es_default = /*#__PURE__*/__webpack_require__.n(es);
;// CONCATENATED MODULE: ./src/helper/srcset.tsx
function srcset(image, size) {
    var rows = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, cols = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    return {
        src: "".concat(image, "?w=").concat(size * cols, "&h=").concat(size * rows, "&fit=crop&auto=format"),
        srcSet: "".concat(image, "?w=").concat(size * cols, "&h=").concat(size * rows, "&fit=crop&auto=format&dpr=2 2x")
    };
}

;// CONCATENATED MODULE: ./src/components/common/sv-modal/index.tsx


var SVModal = function(param) {
    var _id = param.id, id = _id === void 0 ? "sv-modal" : _id, _children = param.children, children = _children === void 0 ? null : _children, _classNames = param.classNames, classNames = _classNames === void 0 ? "" : _classNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "modal fade",
        id: id,
        "tab-index": "-1",
        "aria-labelledby": "".concat(id, "Label"),
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal-dialog ".concat(classNames),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-content",
                children: children
            })
        })
    });
};
// SVModal.Header Component
var Header = function(param) {
    var _children = param.children, children = _children === void 0 ? null : _children, _classNames = param.classNames, classNames = _classNames === void 0 ? "" : _classNames, _closeButton = param.closeButton, closeButton = _closeButton === void 0 ? true : _closeButton, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "modal-header ".concat(classNames),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "btn sv-close-btn btn-close",
                type: "button",
                "data-bs-dismiss": "modal",
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/sv-modal-cross-icon.svg",
                    alt: "Cross icon"
                })
            })
        ]
    });
};
Header.displayName = "SVModal.Header";
// SVModal.Body Component
var Body = function(param) {
    var _children = param.children, children = _children === void 0 ? null : _children, _classNames = param.classNames, classNames = _classNames === void 0 ? "" : _classNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "modal-body ".concat(classNames),
        children: children
    });
};
Body.displayName = "SVModal.Body";
// SVModal.Footer Component
var Footer = function(param) {
    var _children = param.children, children = _children === void 0 ? null : _children, _classNames = param.classNames, classNames = _classNames === void 0 ? "" : _classNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "modal-footer ".concat(classNames),
        children: children
    });
};
Footer.displayName = "SVModal.Footer";
SVModal.Header = Header;
SVModal.Body = Body;
SVModal.Footer = Footer;
/* harmony default export */ var sv_modal = (SVModal);

;// CONCATENATED MODULE: ./src/components/store-locator/revamp/image-gallery/buttons.tsx
/* eslint-disable no-nested-ternary */ 




var Buttons = function(props) {
    var id = props.id, videoId = props.videoId, onPlayVideoBtnClick = props.onPlayVideoBtnClick, isMobile = props.isMobile;
    var ref = (0,next_router.useRouter)(), locale = ref.locale, asPath = ref.asPath;
    var ref1 = (0,react.useState)(false), switchUrl = ref1[0], setSwitchUrl = ref1[1];
    var ref2 = (0,react.useState)(""), prevRoute = ref2[0], setPrevRoute = ref2[1];
    (0,react.useEffect)(function() {
        var switchLocale = JSON.parse(sessionStorage.getItem("switchLocale"));
        var currentUrl = {
            path: asPath,
            locale: locale,
            domain: "https://www.depotium.com",
            switchLocale: switchLocale
        };
        var preRoute = JSON.parse(sessionStorage.getItem("preRoute"));
        var getPreRoute = JSON.parse(sessionStorage.getItem("prevRoute"));
        var getUpdateRoute = JSON.parse(sessionStorage.getItem("updateRou"));
        if (getPreRoute && getPreRoute.locale === locale && (preRoute !== getUpdateRoute || !preRoute && !getUpdateRoute)) {
            setPrevRoute(getPreRoute.path);
            setSwitchUrl(false);
            sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
            sessionStorage.setItem("switchLocale", JSON.stringify(locale));
        } else {
            setSwitchUrl(true);
            if (preRoute && locale !== switchLocale) {
                var switchRou = preRoute.switchLocale, domain = preRoute.domain, path = preRoute.path, lng = preRoute.locale;
                var url = preRoute && switchRou ? "".concat(domain, "/").concat(switchRou).concat(path) : "".concat(domain, "/").concat(lng).concat(path);
                setPrevRoute(url);
                sessionStorage.setItem("updateRou", JSON.stringify(currentUrl));
                sessionStorage.setItem("prevRoute", null);
            } else if (getUpdateRoute && preRoute && preRoute !== getUpdateRoute) {
                var domain1 = getUpdateRoute.domain, path1 = getUpdateRoute.path, lng1 = getUpdateRoute.locale;
                var url1 = getUpdateRoute && getUpdateRoute.locale && "".concat(domain1, "/").concat(lng1).concat(path1);
                setPrevRoute(url1);
                sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
                sessionStorage.setItem("prevRoute", null);
            } else if (!preRoute && !getUpdateRoute && !getPreRoute) {
                setPrevRoute("".concat("https://www.depotium.com", "/").concat(locale).concat(asPath));
                sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
                sessionStorage.setItem("switchLocale", JSON.stringify(locale));
            } else {
                setPrevRoute("".concat("https://www.depotium.com", "/").concat(locale).concat(asPath));
            }
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sv-image-gallery-btns",
        children: [
            !switchUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: prevRoute,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "btn sv-back-btn",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sv-btn-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/sv-back-btn-arrow.svg",
                                alt: "Back Arrow"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "back"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "btn sv-back-btn",
                // eslint-disable-next-line no-return-assign
                onClick: function() {
                    return window.location.href = prevRoute;
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sv-btn-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/sv-back-btn-arrow.svg",
                            alt: "Back Arrow"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "back"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "btn sv-play-video-btn",
                "aria-label": locale === "en" ? "Play Video" : "Voir vid\xe9o",
                "data-bs-toggle": "modal",
                "data-bs-target": "#".concat(videoId || id),
                onClick: onPlayVideoBtnClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sv-btn-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/sv-play-video-white-icon.svg",
                            alt: locale === "en" ? "Play Video" : "Voir vid\xe9o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "playVideo"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "btn sv-back-btn btn-position",
                "aria-label": locale === "en" ? "10+ Photos" : "Photos 10+",
                "data-bs-toggle": "modal",
                "data-bs-target": "#".concat(id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sv-btn-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/sv-images-icon.svg",
                            alt: "Images"
                        })
                    }),
                    isMobile ? "10+" : locale === "en" ? "10+ Photos" : "Photos 10+"
                ]
            })
        ]
    });
};
/* harmony default export */ var buttons = (Buttons);

;// CONCATENATED MODULE: ./src/components/store-locator/image-gallery-slide.tsx











var defaultControlsConfig = {
    pagingDotsStyle: {
        fill: "white"
    }
};
var ImageSlider = function(param) {
    var images = param.images, isMobile = param.isMobile, promotions = param.promotions;
    var ref, ref1;
    var ref2 = (0,react.useState)(1), autoPlay = ref2[0], setAutoPlay = ref2[1];
    var locale = (0,next_router.useRouter)().locale;
    var firstPromotionTitle = promotions.length > 0 ? promotions[0]["Banner_".concat(locale === "fr" ? "FR" : "EN", "_Title")] : "50% Off 12 weeks"; // Default text if no promotions exist
    var firstPromotionBadge = promotions.length > 0 ? promotions[0]["Banner_".concat(locale === "fr" ? "FR" : "EN", "_Badge")] : "Flash Sale"; // Default text if no promotions exist
    var firstPromotionLink = promotions.length > 0 ? promotions[0]["Banner_".concat(locale === "fr" ? "FR" : "EN", "_Link")] : "#"; // Default text if no promotions exist
    var scrollToUnits = function() {
        setTimeout(function() {
            var reviews = document.getElementById("sv-units-hours-tabs");
            if (!reviews) return;
            window.scrollTo({
                top: reviews.offsetTop - 80,
                behavior: "smooth"
            });
        }, 500);
    };
    var removeAttr = function() {
        var removeInertAttr = document.getElementsByClassName("slide slide-current slide-visible");
        for(var i = 0; i < removeInertAttr.length; i += 1){
            removeInertAttr[i].removeAttribute("inert");
        }
    };
    (0,react.useEffect)(function() {
        removeAttr();
        var htmlElement = document.documentElement;
        var modal = document.getElementById("extraImagesModalMobile");
        if (modal) {
            modal.addEventListener("show.bs.modal", function() {
                htmlElement.classList.add("sv-imagesModal-scroll");
            });
            modal.addEventListener("hidden.bs.modal", function() {
                htmlElement.classList.remove("sv-imagesModal-scroll");
            });
        }
        var handleEscKey = function(event) {
            if (event.key === "Escape") {
                // Handle first modal
                var closeButton1 = document.querySelector('#extraImagesModalMobile [data-bs-dismiss="modal"]');
                if (closeButton1) {
                    closeButton1.click();
                    setAutoPlay(0);
                }
                // Handle second modal
                var closeButton2 = document.querySelector('#playVideo [data-bs-dismiss="modal"]');
                if (closeButton2) {
                    closeButton2.click();
                }
            }
        };
        document.addEventListener("keydown", handleEscKey);
        return function() {
            if (modal) {
                modal.removeEventListener("show.bs.modal", function() {
                    htmlElement.classList.add("sv-imagesModal-scroll");
                });
                modal.removeEventListener("hidden.bs.modal", function() {
                    htmlElement.classList.remove("sv-imagesModal-scroll");
                });
            }
            document.removeEventListener("keydown", handleEscKey);
        };
    }, []);
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "carouselExampleFade",
        className: "carousel slide carousel-fade",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((es_default()), {
                defaultControlsConfig: defaultControlsConfig,
                renderCenterLeftControls: function(param) {
                    var previousSlide = param.previousSlide;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "carousel-control-prev",
                        type: "button",
                        onClick: previousSlide,
                        "aria-label": "Previous",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "carousel-control-prev-icon",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "visually-hidden",
                                children: "Previous"
                            })
                        ]
                    });
                },
                renderCenterRightControls: function(param) {
                    var nextSlide = param.nextSlide;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "carousel-control-next",
                        type: "button",
                        onClick: nextSlide,
                        "aria-label": "Next",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "carousel-control-next-icon",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "visually-hidden",
                                children: "Next"
                            })
                        ]
                    });
                },
                children: (ref = images === null || images === void 0 ? void 0 : images.slice(1, images === null || images === void 0 ? void 0 : images.length)) === null || ref === void 0 ? void 0 : ref.map(function(image) {
                    var ref, ref1, ref2, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: "carousel-item active video-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            sizes: "(max-width: 375px) 300px, (max-width: 576px) 200px, (max-width: 768px) 265px, (max-width: 992px) 200px, (max-width: 1280px) 275px",
                            src: (ref3 = image === null || image === void 0 ? void 0 : (ref = image.Image) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : (ref4 = ref2.formats) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) !== null && ref3 !== void 0 ? ref3 : image === null || image === void 0 ? void 0 : (ref6 = image.Image) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.attributes) === null || ref8 === void 0 ? void 0 : ref8.url,
                            alt: image === null || image === void 0 ? void 0 : (ref9 = image.Image) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : ref11.alternativeText,
                            width: "700",
                            height: "285",
                            className: "d-block w-100",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#extraImagesModalMobile",
                            loading: "lazy"
                        })
                    }, image === null || image === void 0 ? void 0 : image.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons, {
                id: "extraImagesModalMobile",
                videoId: "playVideo",
                isMobile: isMobile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sv_modal, {
                id: "extraImagesModalMobile",
                classNames: "modal-fullscreen",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sv_modal.Header, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "btn sv-play-video-btn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#playVideo",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sv-btn-icon me-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/sv-play-video-white-icon.svg",
                                        alt: locale === "en" ? "Play Video" : "Voir vid\xe9o"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "playVideo"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sv_modal.Body, {
                        classNames: "p-0",
                        children: images && (images === null || images === void 0 ? void 0 : images.slice(1, images === null || images === void 0 ? void 0 : images.length).map(function(image, index) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                style: {
                                    marginBottom: "16px",
                                    width: "100%"
                                }
                            }, srcset((image === null || image === void 0 ? void 0 : (ref = image.Image) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.formats) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.small) === null || ref4 === void 0 ? void 0 : ref4.url) || (image === null || image === void 0 ? void 0 : (ref5 = image.Image) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.attributes) === null || ref7 === void 0 ? void 0 : ref7.url), 200, null, null)), {
                                alt: image === null || image === void 0 ? void 0 : (ref8 = image.Image) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.attributes) === null || ref10 === void 0 ? void 0 : ref10.alternativeText,
                                loading: "lazy"
                            }), (image === null || image === void 0 ? void 0 : (ref11 = image.Image) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.attributes) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.formats) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.small) === null || ref15 === void 0 ? void 0 : ref15.url) || index);
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(sv_modal.Footer, {
                        classNames: "d-flex align-items-center justify-content-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: firstPromotionLink,
                                        className: "sv-deal-pill text-decoration-none mb-2",
                                        id: "dealPill",
                                        children: firstPromotionBadge
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        className: "sv-hour-day mb-0 mt-2",
                                        children: firstPromotionTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn sv-play-video-btn",
                                type: "button",
                                "data-bs-dismiss": "modal",
                                onClick: function() {
                                    return scrollToUnits();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "seeAvailableUnits"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sv_modal, {
                id: "playVideo",
                classNames: "modal-dialog-centered sv-playVideo-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sv_modal.Header, {
                        closeButton: false,
                        classNames: "border-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn sv-close-btn btn-close",
                            type: "button",
                            "data-bs-dismiss": "modal",
                            onClick: function() {
                                return setAutoPlay(0);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/sv-modal-cross-icon.svg",
                                alt: "Cross icon"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sv_modal.Body, {
                        classNames: "p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            style: {
                                borderRadius: "10px",
                                transform: "translateZ(0px)"
                            },
                            src: "".concat(images === null || images === void 0 ? void 0 : (ref1 = images[0]) === null || ref1 === void 0 ? void 0 : ref1.Video_URL, "?h=500&autoplay=").concat(autoPlay, "&muted=1&controls=1&loop=0"),
                            width: "100%",
                            height: "400",
                            loading: "lazy"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var image_gallery_slide = (ImageSlider);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/services/store-locator/index.tsx
var services_store_locator = __webpack_require__(93342);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
;// CONCATENATED MODULE: ./src/components/store-locator/revamp/address.tsx







var AddressComponent = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var facilityData = props.facilityData, isDesktop = props.isDesktop;
    var locale = (0,next_router.useRouter)().locale;
    var ref6 = (0,react.useState)(null), officeAddressName = ref6[0], setOfficeAddressName = ref6[1];
    var getFacilityDataOffice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(defaultBrand) {
            var ref, ref1, ref2, ref3, ref4, getOffice, officeName;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,services_store_locator/* getFacilityPageDataOffice */.QS)(facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : ref.Office_Facility_ID, defaultBrand, locale)
                        ];
                    case 1:
                        getOffice = _state.sent();
                        officeName = (ref2 = getOffice === null || getOffice === void 0 ? void 0 : (ref1 = getOffice.data) === null || ref1 === void 0 ? void 0 : ref1.data[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Address) === null || ref4 === void 0 ? void 0 : ref4.Street_1;
                        setOfficeAddressName(officeName);
                        return [
                            2
                        ];
                }
            });
        });
        return function getFacilityDataOffice(defaultBrand) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var defaultBrand = constants/* BRAND_NAME_EN */.Vp;
        if (locale === "fr") defaultBrand = constants/* BRAND_NAME_FR */.Fj;
        getFacilityDataOffice(defaultBrand);
    }, [
        facilityData
    ]);
    var Address = facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : ref.Address;
    var placeId = facilityData === null || facilityData === void 0 ? void 0 : (ref1 = facilityData.attributes) === null || ref1 === void 0 ? void 0 : ref1.Google_PlaceID;
    var PhoneNumber = facilityData === null || facilityData === void 0 ? void 0 : (ref2 = facilityData.attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Support) === null || ref3 === void 0 ? void 0 : ref3.Phone_Number;
    var GMBNumber = facilityData === null || facilityData === void 0 ? void 0 : (ref4 = facilityData.attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Support) === null || ref5 === void 0 ? void 0 : ref5.GMB_Phone_Number;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "sv-address-navigation d-flex align-items-center flex-md-wrap",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex align-items-center addressNavigation",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "sv-storeAddress mb-0",
                            children: [
                                Address === null || Address === void 0 ? void 0 : Address.Street_1,
                                Address === null || Address === void 0 ? void 0 : Address.Street_2,
                                ", ",
                                Address === null || Address === void 0 ? void 0 : Address.City,
                                " ",
                                Address === null || Address === void 0 ? void 0 : Address.Postal_Code,
                                officeAddressName && " (Office: ".concat(officeAddressName, ")")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn sv-navigation-btn ms-2 borderless-btn",
                            "aria-label": "Open Google Maps directions",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.google.com/maps/search/?api=1&query=%20&query_place_id=".concat(placeId, " "),
                                className: "borderless-btn text-decoration-none",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/navigation-pointer.svg",
                                    alt: "Navigation"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(isDesktop ? "w-100" : "", " mt-md-3"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn sv-revamp-blue-btn",
                        "aria-label": "Call store",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "tel:".concat(PhoneNumber || GMBNumber),
                            className: "text-decoration-none text-white",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/sv-phone-icon.svg",
                                    alt: "phone icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ms-2",
                                    children: isDesktop ? PhoneNumber || GMBNumber : "Call Store"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var address = (AddressComponent);

// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(37054);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.js
var dist = __webpack_require__(50549);
;// CONCATENATED MODULE: ./src/static/assets/map-pin-blue.svg
/* harmony default export */ var map_pin_blue = ({"src":"/_next/static/media/map-pin-blue.4be68862.svg","height":37,"width":95});
// EXTERNAL MODULE: ./src/components/store-locator/revamp/map-view.module.scss
var map_view_module = __webpack_require__(9271);
var map_view_module_default = /*#__PURE__*/__webpack_require__.n(map_view_module);
;// CONCATENATED MODULE: ./src/components/store-locator/revamp/map-view.tsx







var apiKey = "AIzaSyAaBx7TQH_tyxAJLYYwkbudZSk9jz69Hgw";
var options = {
    streetViewControl: false,
    mapTypeControl: false,
    minZoom: 6,
    maxZoom: 15,
    gestureHandling: "greedy",
    componentRestrictions: {
        country: "ca"
    },
    draggable: false,
    disableDefaultUI: true,
    fullscreenControl: false
};
var MapView = function(props) {
    var ref;
    var facilityData = props.facilityData;
    var isLoaded = (0,esm/* useJsApiLoader */.Ji)({
        googleMapsApiKey: apiKey
    }).isLoaded;
    var locale = (0,next_router.useRouter)().locale;
    var mapRef = (0,react.useRef)(null);
    var Address = facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : ref.Address;
    var latlngLocation = Address === null || Address === void 0 ? void 0 : Address.Location;
    var getLatLng = function() {
        var lngLatObj;
        if (Address === null || Address === void 0 ? void 0 : Address.Latitude) {
            lngLatObj = {
                lat: parseFloat(Address.Latitude),
                lng: parseFloat(Address.Longitude)
            };
        } else if ((Address === null || Address === void 0 ? void 0 : Address.Latitude) === null && (Address === null || Address === void 0 ? void 0 : Address.Longitude) === null) {
            var location = Address === null || Address === void 0 ? void 0 : Address.Location.split("(")[1].slice(0, -1);
            var newLocation = location.split(" ");
            lngLatObj = {
                lat: parseFloat(newLocation[1]),
                lng: parseFloat(newLocation[0])
            };
        } else if (latlngLocation) {
            var ref;
            var regExp = /\(([^)]+)\)/;
            var latlngObj = (ref = regExp.exec(latlngLocation)) === null || ref === void 0 ? void 0 : ref[1].split(" ");
            lngLatObj = {
                lat: parseFloat(latlngObj[0]),
                lng: parseFloat(latlngObj[1])
            };
        } else {
            lngLatObj = {
                lat: 51.0553635,
                lng: -114.0186927
            };
        }
        return lngLatObj;
    };
    (0,react.useEffect)(function() {
        var handleFullscreenChange = function() {
            var expandControl = document.querySelector(".".concat((map_view_module_default()).customExpandMap));
            var exitControl = document.querySelector(".".concat((map_view_module_default()).customExitFullscreen));
            var mapContainer = document.querySelector(".locator-google-map");
            var isFullscreen = !!document.fullscreenElement || (mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.classList.contains((map_view_module_default()).fullscreenMode));
            if (expandControl) expandControl.style.display = isFullscreen ? "none" : "flex";
            if (exitControl) exitControl.style.display = isFullscreen ? "block" : "none";
            document.body.style.overflow = isFullscreen ? "hidden" : "auto";
        };
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return function() {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
            document.body.style.overflow = "auto";
        };
    }, []);
    var onLoad = function(map) {
        mapRef.current = map;
        var expandControl = document.createElement("div");
        expandControl.className = (map_view_module_default()).customExpandMap;
        var icon = document.createElement("img");
        icon.src = "/images/icons/expand-icon.svg";
        icon.alt = "map icon";
        icon.className = (map_view_module_default()).expandIcon;
        var text = document.createElement("span");
        text.textContent = locale === "en" ? "Expand Map" : "Agrandir la carte";
        text.classList.add("st-expand-map");
        expandControl.appendChild(icon);
        expandControl.appendChild(text);
        var mapContainer = document.querySelector(".locator-google-map");
        var exitControl = document.createElement("div");
        exitControl.className = (map_view_module_default()).customExitFullscreen;
        var exitCross = document.createElement("img");
        exitCross.src = "/images/sv-modal-cross-icon.svg";
        exitCross.alt = "Close";
        exitCross.className = (map_view_module_default()).exitCross;
        exitControl.appendChild(exitCross);
        mapContainer.appendChild(exitControl);
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        var supportsFullscreen = !!mapContainer.requestFullscreen;
        expandControl.addEventListener("click", function() {
            if (isIOS || !supportsFullscreen) {
                mapContainer.classList.add((map_view_module_default()).fullscreenMode);
                exitControl.style.display = "block";
                expandControl.style.display = "none";
                document.body.style.overflow = "hidden";
            } else {
                mapContainer.requestFullscreen().catch(function(err) {
                    console.error("Fullscreen request failed:", err);
                });
            }
        });
        exitControl.addEventListener("click", function() {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            }
            if (mapContainer.classList.contains((map_view_module_default()).fullscreenMode)) {
                mapContainer.classList.remove((map_view_module_default()).fullscreenMode);
                exitControl.style.display = "none";
                expandControl.style.display = "flex";
                document.body.style.overflow = "auto";
            }
        });
        map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(expandControl);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isLoaded && (Address === null || Address === void 0 ? void 0 : Address.Location) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "sv-revamp-map-container position-relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* GoogleMap */.b6, {
                mapContainerStyle: {
                    width: "100%",
                    height: "100%"
                },
                center: getLatLng(),
                zoom: 12,
                options: options,
                mapContainerClassName: "locator-google-map",
                onLoad: onLoad,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MarkerF */.jC, {
                    position: getLatLng(),
                    icon: {
                        url: map_pin_blue,
                        anchor: new window.google.maps.Point(55, 20),
                        labelOrigin: new window.google.maps.Point(55, 15),
                        scaledSize: new window.google.maps.Size(110, 40)
                    }
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            height: "180"
        })
    });
};
/* harmony default export */ var map_view = (MapView);

;// CONCATENATED MODULE: ./src/components/store-locator/revamp/store-promotions.tsx



var StorePromotions = function(param) {
    var promotions = param.promotions;
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var getLocalizedValue = function(field, promo) {
        switch(locale){
            case "fr":
                return promo["Banner_FR_".concat(field)] || "";
            case "en":
            default:
                return promo["Banner_EN_".concat(field)] || "";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "sv-promo-carousel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "customCarousel",
                className: "carousel slide",
                "data-bs-ride": "carousel",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "carousel-indicators",
                        children: promotions.map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                "data-bs-target": "#customCarousel",
                                "data-bs-slide-to": index,
                                className: index === 0 ? "active" : "",
                                "aria-current": index === 0 ? "true" : undefined,
                                "aria-label": "Slide ".concat(index + 1)
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "carousel-inner",
                        children: promotions.map(function(promo, index) {
                            var badge = getLocalizedValue("Badge", promo);
                            var title = getLocalizedValue("Title", promo);
                            var subTitle = getLocalizedValue("Subtitle", promo);
                            var date = getLocalizedValue("Date", promo);
                            var link = getLocalizedValue("Link", promo);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "carousel-item  ".concat(index === 0 ? "active" : "", " banner-").concat(promo.Banner_Color_Set),
                                children: promo.Only_Image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "carousel-item-img-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (promo === null || promo === void 0 ? void 0 : promo.image) || "Promotion Image",
                                        className: "carousel-image-full",
                                        alt: "Promotion"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row align-items-center",
                                    children: [
                                        (promo === null || promo === void 0 ? void 0 : promo.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-lg-4 col-md-4 col-sm-5 col-xs-4 col-4 carousel-item-align",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "carousel-item-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: (promo === null || promo === void 0 ? void 0 : promo.image) || "Promotion Image",
                                                    className: "carousel-image",
                                                    alt: "Storage Image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sv-promo-carousel-responsive ".concat((promo === null || promo === void 0 ? void 0 : promo.image) ? "col-lg-8 col-md-8 col-sm-7 col-6 col-xs-6" : "col-lg-12 col-md-12 col-sm-12 col-12 carousel-content-only"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "carousel-content",
                                                children: [
                                                    badge && (link ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: link,
                                                        className: "sv-pill-link mb-2",
                                                        children: [
                                                            badge,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "sv-pill-arrow",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/images/sv-pill-arrow.svg",
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "badge sv-pill-link mb-2",
                                                        children: badge
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        className: "sv-gray-large-heading mb-1",
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex justify-content-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "sv-dark-black-bold-para mb-0",
                                                                children: subTitle
                                                            }),
                                                            link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: link,
                                                                className: "sv-offer-deadline text-decoration-none",
                                                                children: date
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "sv-offer-deadline mb-0",
                                                                children: date
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }, promo.concessionID);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "carousel-control-prev",
                        type: "button",
                        "data-bs-target": "#customCarousel",
                        "data-bs-slide": "prev",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "custom-carousel-icon carousel-control-prev-icon",
                            "aria-hidden": "true"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "carousel-control-next",
                        type: "button",
                        "data-bs-target": "#customCarousel",
                        "data-bs-slide": "next",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "custom-carousel-icon carousel-control-next-icon",
                            "aria-hidden": "true"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var store_promotions = (StorePromotions);

// EXTERNAL MODULE: ./src/components/stars/index.tsx
var stars = __webpack_require__(88803);
;// CONCATENATED MODULE: ./src/components/store-locator/revamp/title-desc.tsx




var TitleDescription = function(props) {
    var ref, ref1, ref2;
    var facilityData = props.facilityData, ratingData = props.ratingData;
    var ref3 = (0,react.useState)(false), showStoreId = ref3[0], setShowStoreId = ref3[1];
    var scrollToReviews = function() {
        var reviews = document.getElementById("client-reviews-google");
        if (!reviews) return;
        window.scrollTo({
            top: reviews.offsetTop - 128,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        var handleKeyPress = function(event) {
            if (event.shiftKey && event.key.toUpperCase() === "L") {
                setShowStoreId(function(prev) {
                    return !prev;
                });
            }
        };
        // Add event listener on mount
        window.addEventListener("keydown", handleKeyPress);
        // Cleanup the event listener on unmount
        return function() {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex align-items-center mt-3 mb-2",
                children: [
                    (ratingData === null || ratingData === void 0 ? void 0 : ratingData.averageRating) != null && !Number.isNaN(ratingData.averageRating) && /*#__PURE__*/ (0,jsx_runtime.jsx)(stars/* default */.Z, {
                        data: ratingData === null || ratingData === void 0 ? void 0 : ratingData.averageRating,
                        toggleText: true,
                        children: ratingData === null || ratingData === void 0 ? void 0 : ratingData.averageRating
                    }),
                    (ratingData === null || ratingData === void 0 ? void 0 : ratingData.numberOfReviews) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                        className: "sv-storeAddress mb-0 mt-1 ms-2",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: function() {
                            return scrollToReviews();
                        },
                        children: [
                            ratingData === null || ratingData === void 0 ? void 0 : ratingData.numberOfReviews,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "reviews-of"
                            }),
                            "  ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/right-blue-arrow.svg",
                                alt: "Arrow icon"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sv-storeNameID",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        className: "sv-storeName mb-0",
                        children: facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : ref.Title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sv-storeID ms-2",
                        id: "store-id",
                        style: {
                            display: showStoreId ? "inline-block" : "none"
                        },
                        children: facilityData === null || facilityData === void 0 ? void 0 : (ref1 = facilityData.attributes) === null || ref1 === void 0 ? void 0 : ref1.Facility_ID
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "sv-store-description mb-0",
                dangerouslySetInnerHTML: {
                    __html: facilityData === null || facilityData === void 0 ? void 0 : (ref2 = facilityData.attributes) === null || ref2 === void 0 ? void 0 : ref2.Facility_Description
                }
            })
        ]
    });
};
/* harmony default export */ var title_desc = (TitleDescription);

;// CONCATENATED MODULE: ./src/components/store-locator/revamp/top-features.tsx



var TopFeatures = function(props) {
    var facilityData = props.facilityData;
    var ref = (0,react.useState)([]), topFeatures = ref[0], setTopFeatures = ref[1];
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        var sorted = facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.Features) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.sort(function(a, b) {
            var _priority;
            var priorityA = (_priority = a.attributes.priority) !== null && _priority !== void 0 ? _priority : Infinity;
            var _priority1;
            var priorityB = (_priority1 = b.attributes.priority) !== null && _priority1 !== void 0 ? _priority1 : Infinity;
            return priorityA - priorityB;
        });
        setTopFeatures(sorted);
    }, [
        facilityData
    ]);
    (0,react.useEffect)(function() {
        var handleEscKey = function(event) {
            if (event.key === "Escape") {
                var closeButton = document.querySelector('[data-bs-dismiss="modal"]');
                if (closeButton) {
                    closeButton.click();
                }
            }
        };
        document.addEventListener("keydown", handleEscKey);
        return function() {
            return document.removeEventListener("keydown", handleEscKey);
        };
    }, []);
    var defaultIcon = "/images/features-tick-icon.svg";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sv-store-features",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sv-store-top-features",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "sub-heading mb-0 text-black",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "topFeatures"
                                })
                            }),
                            (topFeatures === null || topFeatures === void 0 ? void 0 : topFeatures.length) > 6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "btn btn-link sv-storeAddress p-0 text-decoration-none p-0",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#featuresModal",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "seeAll"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/right-blue-arrow.svg",
                                            alt: "right arrow"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row unitFeaturesContent",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6",
                                children: topFeatures === null || topFeatures === void 0 ? void 0 : topFeatures.slice(0, 3).map(function(feature, index) {
                                    var ref, ref1, ref2;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: "featuresList",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: ((ref = feature === null || feature === void 0 ? void 0 : feature.attributes.Icon) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url) || defaultIcon,
                                                alt: "feature icon",
                                                className: "feature-icon me-3"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sv-feature-name ellipsis",
                                                children: feature === null || feature === void 0 ? void 0 : feature.attributes.Title
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6",
                                children: topFeatures === null || topFeatures === void 0 ? void 0 : topFeatures.slice(3, 6).map(function(feature, index) {
                                    var ref, ref1, ref2;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex align-items-center mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: ((ref = feature === null || feature === void 0 ? void 0 : feature.attributes.Icon) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url) || defaultIcon,
                                                alt: "feature icon",
                                                className: "feature-icon me-3"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sv-feature-name ellipsis",
                                                children: feature === null || feature === void 0 ? void 0 : feature.attributes.Title
                                            })
                                        ]
                                    }, index + 3);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sv-store-top-features-responsive",
                        children: topFeatures.length > 6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "btn btn-link sv-storeAddress p-0 w-100 text-decoration-none",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#featuresModal",
                            children: [
                                "All Features",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/sv-plus-icon.svg",
                                        alt: "add"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal fade",
                id: "featuresModal",
                role: "dialog",
                "aria-labelledby": "featuresModalLabel",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-dialog modal-dialog-centered",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal-header",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn-close sv-close-btn",
                                    "data-bs-dismiss": "modal",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/sv-modal-cross-icon.svg",
                                        alt: "Cross icon"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "modal-body p-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "sv-features-modal",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex justify-content-between align-items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "sv-dark-black-bold-para sub-heading",
                                                    id: "featuresModalLabel",
                                                    children: "Top Features"
                                                })
                                            }),
                                            topFeatures === null || topFeatures === void 0 ? void 0 : topFeatures.slice(0, 3).map(function(feature, index) {
                                                var ref, ref1, ref2;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                    className: "featuresList",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: ((ref = feature === null || feature === void 0 ? void 0 : feature.attributes.Icon) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url) || defaultIcon,
                                                            alt: "feature icon",
                                                            className: "feature-icon me-2"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "sv-feature-title mb-0",
                                                                    children: feature === null || feature === void 0 ? void 0 : feature.attributes.Title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "sv-feature-description mb-0",
                                                                    children: feature === null || feature === void 0 ? void 0 : feature.attributes.Description
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sv-features-grid",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row align-items-center",
                                            children: topFeatures === null || topFeatures === void 0 ? void 0 : topFeatures.slice(3).map(function(feature, index) {
                                                var ref, ref1, ref2;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    className: "col-lg-6 col-md-6 col-sm-6 col-6 featuresList",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: ((ref = feature === null || feature === void 0 ? void 0 : feature.attributes.Icon) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url) || defaultIcon,
                                                                alt: "feature icon",
                                                                className: "feature-icon me-2"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "sv-feature-title",
                                                                children: feature === null || feature === void 0 ? void 0 : feature.attributes.Title
                                                            })
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var top_features = (TopFeatures);

// EXTERNAL MODULE: ./src/helper/convertTimeFormat.tsx
var convertTimeFormat = __webpack_require__(41165);
;// CONCATENATED MODULE: ./src/components/store-locator/store-hours.tsx




var todayIndex = new Date().getDay();
var Hours = function(props) {
    var openHours = props.openHours, storeHours = props.storeHours;
    var gateAccessDaysOfWeek = Object.keys(openHours);
    var locale = (0,next_router.useRouter)().locale;
    var renderRow = function(dayName, dayIndex) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("tr", {
            className: todayIndex === dayIndex ? "active-hour" : "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "shortDays.".concat(dayName)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    children: (openHours === null || openHours === void 0 ? void 0 : openHours[dayName]) ? (0,convertTimeFormat/* default */.Z)(openHours === null || openHours === void 0 ? void 0 : openHours[dayName], locale) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "text.closed"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    children: (storeHours === null || storeHours === void 0 ? void 0 : storeHours[dayName]) ? (0,convertTimeFormat/* default */.Z)(storeHours === null || storeHours === void 0 ? void 0 : storeHours[dayName], locale) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "text.closed"
                    })
                })
            ]
        }, dayIndex);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        className: "table sv-hours-revamp-table sv-store-hours-bold text-center mb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    className: "align-middle",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            scope: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "days"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            scope: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "gateHours"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            scope: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "officeHours"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                children: gateAccessDaysOfWeek.map(function(day, index) {
                    return day !== "id" && renderRow(day, index);
                })
            })
        ]
    });
};
/* harmony default export */ var store_hours = (Hours);

;// CONCATENATED MODULE: ./src/components/store-locator/mobile-banner.tsx














var MobileBanner = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var facilityData = props.facilityData, ratingData = props.ratingData, promotions = props.promotions;
    var citySlug = facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : ref.City_Slug;
    var ref6 = (0,next_router.useRouter)(), query = ref6.query, locale = ref6.locale, asPath = ref6.asPath;
    var cords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var getCity = query && query.location && query.location[0];
    var getStore = query && query.location && query.location[1] ? facilityData === null || facilityData === void 0 ? void 0 : (ref1 = facilityData.attributes) === null || ref1 === void 0 ? void 0 : ref1.Title : null;
    var cityName = (0,wordReplace/* capitalizeFirstLetterOfWords */.bs)(getCity);
    var cityStore = (0,wordReplace/* capitalizeFirstLetterOfWords */.bs)(getStore);
    var handleClick = function() {
        cords.setLatLog({});
        cords.setLatLogCity({});
    };
    (0,react.useEffect)(function() {
        var switchLocale = JSON.parse(sessionStorage.getItem("switchLocale"));
        var currentUrl = {
            path: asPath,
            locale: locale,
            domain: "https://www.depotium.com",
            switchLocale: switchLocale
        };
        var preRoute = JSON.parse(sessionStorage.getItem("preRoute"));
        var getPreRoute = JSON.parse(sessionStorage.getItem("prevRoute"));
        var getUpdateRoute = JSON.parse(sessionStorage.getItem("updateRou"));
        if (getPreRoute && getPreRoute.locale === locale && (preRoute !== getUpdateRoute || !preRoute && !getUpdateRoute)) {
            sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
            sessionStorage.setItem("switchLocale", JSON.stringify(locale));
        } else if (preRoute && locale !== switchLocale) {
            sessionStorage.setItem("updateRou", JSON.stringify(currentUrl));
            sessionStorage.setItem("prevRoute", null);
        } else if (getUpdateRoute && preRoute && preRoute !== getUpdateRoute) {
            sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
            sessionStorage.setItem("prevRoute", null);
        } else if (!preRoute && !getUpdateRoute && !getPreRoute) {
            sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
            sessionStorage.setItem("switchLocale", JSON.stringify(locale));
        }
    }, [
        facilityData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "sv-breadcrumb-revamp",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                "aria-label": "breadcrumb",
                                className: "d-flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                    className: "breadcrumb",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "breadcrumb-item",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/",
                                                prefetch: false,
                                                children: locale === "en" ? "Home" : "Accueil"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "breadcrumb-separator"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "breadcrumb-item",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: locale === "en" ? "/en/self-storage" : "/entreposage-libre-service",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: handleClick,
                                                    children: locale === "en" ? "Locations" : "Succursales"
                                                })
                                            })
                                        }),
                                        (query === null || query === void 0 ? void 0 : query.location[0]) && (query === null || query === void 0 ? void 0 : query.location[1]) && !citySlug ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "breadcrumb-separator"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "breadcrumb-item",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "".concat(locale === "en" ? "/en/self-storage" : "/entreposage-libre-service", "/[...location]"),
                                                        as: "".concat(locale === "en" ? "/en/self-storage" : "/entreposage-libre-service", "/").concat(query === null || query === void 0 ? void 0 : query.location[0]),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: cityName
                                                        })
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "breadcrumb-separator"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "breadcrumb-item active",
                                                    children: cityName
                                                })
                                            ]
                                        }),
                                        cityStore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "breadcrumb-separator"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "breadcrumb-item active",
                                                    "aria-current": "page",
                                                    children: cityStore
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "gallery",
                        children: (facilityData === null || facilityData === void 0 ? void 0 : (ref2 = facilityData.attributes) === null || ref2 === void 0 ? void 0 : ref2.Facility_Gallery) && /*#__PURE__*/ (0,jsx_runtime.jsx)(image_gallery_slide, {
                            images: facilityData === null || facilityData === void 0 ? void 0 : (ref3 = facilityData.attributes) === null || ref3 === void 0 ? void 0 : ref3.Facility_Gallery,
                            isMobile: true,
                            promotions: promotions
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_desc, {
                            facilityData: facilityData,
                            ratingData: ratingData
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(address, {
                        facilityData: facilityData
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "sv-store-features-tabs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "nav nav-tabs d-flex w-100 flex-nowrap p-0 m-0",
                            id: "myTab",
                            role: "tablist",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "nav-item flex-fill text-center",
                                    role: "presentation",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "nav-link active w-100",
                                        id: "home-tab",
                                        "data-bs-toggle": "tab",
                                        "data-bs-target": "#home-tab-pane",
                                        type: "button",
                                        role: "tab",
                                        "aria-controls": "home-tab-pane",
                                        "aria-selected": "true",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tab-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/sv-maps-icon.svg",
                                                    alt: "Maps"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "map"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "nav-item flex-fill text-center",
                                    role: "presentation",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "nav-link w-100",
                                        id: "features-tab",
                                        "data-bs-toggle": "tab",
                                        "data-bs-target": "#features-tab-pane",
                                        type: "button",
                                        role: "tab",
                                        "aria-controls": "features-tab-pane",
                                        "aria-selected": "false",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tab-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/sv-features-icon.svg",
                                                    alt: "features"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "features"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "nav-item flex-fill text-center",
                                    role: "presentation",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "nav-link w-100",
                                        id: "hours-revamp-tab",
                                        "data-bs-toggle": "tab",
                                        "data-bs-target": "#hours-revamp-tab-pane",
                                        type: "button",
                                        role: "tab",
                                        "aria-controls": "hours-revamp-tab-pane",
                                        "aria-selected": "false",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tab-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/sv-alarm-clock-icon.svg",
                                                    alt: "hours"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "hours"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tab-content",
                            id: "myTabContent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tab-pane fade show active",
                                    id: "home-tab-pane",
                                    role: "tabpanel",
                                    "aria-labelledby": "home-tab",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(map_view, {
                                        facilityData: facilityData
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tab-pane fade",
                                    id: "features-tab-pane",
                                    role: "tabpanel",
                                    "aria-labelledby": "features-tab",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_features, {
                                        facilityData: facilityData
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tab-pane fade",
                                    id: "hours-revamp-tab-pane",
                                    role: "tabpanel",
                                    "aria-labelledby": "hours-revamp-tab",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(store_hours, {
                                        openHours: facilityData === null || facilityData === void 0 ? void 0 : (ref4 = facilityData.attributes) === null || ref4 === void 0 ? void 0 : ref4.Open_Hours,
                                        storeHours: facilityData === null || facilityData === void 0 ? void 0 : (ref5 = facilityData.attributes) === null || ref5 === void 0 ? void 0 : ref5.Store_Hours
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(store_promotions, {
                    promotions: promotions
                })
            })
        ]
    });
};
/* harmony default export */ var mobile_banner = (MobileBanner);

;// CONCATENATED MODULE: ./src/components/store-locator/revamp/breadcrumb.tsx






var Breadcrumb = function(props) {
    var ref, ref1;
    var facilityData = props.facilityData;
    var ref2 = (0,next_router.useRouter)(), query = ref2.query, locale = ref2.locale, asPath = ref2.asPath;
    var getCity = query && query.location && query.location[0];
    var getStore = query && query.location && query.location[1] ? facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : ref.Title : null;
    var cityName = (0,wordReplace/* capitalizeFirstLetterOfWords */.bs)(getCity);
    var cityStore = (0,wordReplace/* capitalizeFirstLetterOfWords */.bs)(getStore);
    var citySlug = facilityData === null || facilityData === void 0 ? void 0 : (ref1 = facilityData.attributes) === null || ref1 === void 0 ? void 0 : ref1.City_Slug;
    var cords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    (0,react.useEffect)(function() {
        var switchLocale = JSON.parse(sessionStorage.getItem("switchLocale"));
        var currentUrl = {
            path: asPath,
            locale: locale,
            domain: "https://www.depotium.com",
            switchLocale: switchLocale
        };
        var preRoute = JSON.parse(sessionStorage.getItem("preRoute"));
        var getPreRoute = JSON.parse(sessionStorage.getItem("prevRoute"));
        var getUpdateRoute = JSON.parse(sessionStorage.getItem("updateRou"));
        if (getPreRoute && getPreRoute.locale === locale && (preRoute !== getUpdateRoute || !preRoute && !getUpdateRoute)) {
            sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
            sessionStorage.setItem("switchLocale", JSON.stringify(locale));
        } else if (preRoute && locale !== switchLocale) {
            sessionStorage.setItem("updateRou", JSON.stringify(currentUrl));
            sessionStorage.setItem("prevRoute", null);
        } else if (getUpdateRoute && preRoute && preRoute !== getUpdateRoute) {
            sessionStorage.setItem("prevRoute", null);
        } else if (!preRoute && !getUpdateRoute && !getPreRoute) {
            sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
            sessionStorage.setItem("switchLocale", JSON.stringify(locale));
        }
    }, [
        facilityData
    ]);
    var handleClick = function() {
        cords.setLatLog({});
        cords.setLatLogCity({});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "sv-breadcrumb-revamp",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
            "aria-label": "breadcrumb",
            className: "d-flex mb-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                className: "breadcrumb",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "breadcrumb-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            prefetch: false,
                            children: locale === "en" ? "Home" : "Accueil"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "breadcrumb-separator"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "breadcrumb-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: locale === "en" ? "/en/self-storage" : "/entreposage-libre-service",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: handleClick,
                                children: locale === "en" ? "Locations" : "Succursales"
                            })
                        })
                    }),
                    (query === null || query === void 0 ? void 0 : query.location[0]) && (query === null || query === void 0 ? void 0 : query.location[1]) && !citySlug ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "breadcrumb-separator"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "breadcrumb-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "".concat(locale === "en" ? "/en/self-storage" : "/entreposage-libre-service", "/").concat(query === null || query === void 0 ? void 0 : query.location[0]),
                                    as: "".concat(locale === "en" ? "/en/self-storage" : "/entreposage-libre-service", "/").concat(query === null || query === void 0 ? void 0 : query.location[0]),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: cityName
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "breadcrumb-separator"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "breadcrumb-item active",
                                children: cityName
                            })
                        ]
                    }),
                    cityStore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "breadcrumb-separator"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "breadcrumb-item active",
                                "aria-current": "page",
                                children: cityStore
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var breadcrumb = (Breadcrumb);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/helper/checkTimes.tsx

function convertEndTime(timeRange, locale) {
    var end = timeRange.split(" - ")[1];
    var endHour = parseInt(end.split(":")[0], 10);
    var endFormatted = endHour > 12 ? "".concat(endHour - 12, " pm") : "".concat(endHour, " am");
    return "".concat(locale === "en" ? "Open until" : "Ouvert jusqu'\xe0", " ").concat(endFormatted);
}
function isBetweenTimes(time) {
    if (!time) return false;
    var timeNow = moment_default()();
    var startTime = moment_default()(time === null || time === void 0 ? void 0 : time.split(" - ")[0], "h:mma");
    var endTime = moment_default()(time === null || time === void 0 ? void 0 : time.split(" - ")[1], "h:mma");
    return timeNow.isBetween(startTime, endTime);
}

;// CONCATENATED MODULE: ./src/components/store-locator/revamp/hours.tsx





var hours_todayIndex = (new Date().getDay() + 6) % 7;
var hours_Hours = function(props) {
    var ref, ref1;
    var facilityData = props.facilityData;
    var gateAccessHours = facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : ref.Open_Hours;
    var officeHours = facilityData === null || facilityData === void 0 ? void 0 : (ref1 = facilityData.attributes) === null || ref1 === void 0 ? void 0 : ref1.Store_Hours;
    var gateAccessDaysOfWeek = Object.keys(gateAccessHours);
    gateAccessDaysOfWeek = gateAccessDaysOfWeek.filter(function(day) {
        return day !== "id";
    });
    var officeDaysOfWeek = Object.keys(officeHours);
    officeDaysOfWeek = officeDaysOfWeek.filter(function(day) {
        return day !== "id";
    });
    var locale = (0,next_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dropdown-center sv-gateAccess-select mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn btn-outline-dark dropdown-toggle w-100 d-flex align-items-center justify-content-between",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hours-dropdown-text",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sv-storeAddress text-black",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "gateAccess"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: isBetweenTimes(gateAccessHours[gateAccessDaysOfWeek[hours_todayIndex]]) ? "blinking-dot" : "dot"
                                }),
                                isBetweenTimes(gateAccessHours[gateAccessDaysOfWeek[hours_todayIndex]]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sv-hours-blue-text",
                                    children: convertEndTime(gateAccessHours[gateAccessDaysOfWeek[hours_todayIndex]], locale)
                                }) : (0,convertTimeFormat/* default */.Z)(gateAccessHours[gateAccessDaysOfWeek[hours_todayIndex]], locale, locale === "en" ? "Open " : "Ouvert ")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "dropdown-menu bg-white w-100",
                        children: gateAccessDaysOfWeek.map(function(day, index) {
                            return day !== "id" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: hours_todayIndex === index ? "sv-current-day" : "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "dropdown-item d-flex align-items-center justify-content-between py-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sv-hour-day",
                                                    style: {
                                                        fontWeight: hours_todayIndex === index ? "bold" : "normal"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "days.".concat(day)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sv-store-description ms-1",
                                                    children: hours_todayIndex === index && "(".concat(locale === "en" ? "Today" : "Aujourd'hui", ")")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sv-hour-time",
                                            children: (0,convertTimeFormat/* default */.Z)(gateAccessHours[day], locale)
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dropdown-center sv-hours-select",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn btn-outline-dark dropdown-toggle w-100 d-flex align-items-center justify-content-between",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hours-dropdown-text",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sv-storeAddress text-black",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "officeHours"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: isBetweenTimes(officeHours[officeDaysOfWeek[hours_todayIndex]]) ? "blinking-dot" : "dot"
                                }),
                                isBetweenTimes(officeHours[officeDaysOfWeek[hours_todayIndex]]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sv-hours-blue-text",
                                    children: convertEndTime(officeHours[officeDaysOfWeek[hours_todayIndex]], locale)
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sv-hours-open-text",
                                    children: (0,convertTimeFormat/* default */.Z)(officeHours[officeDaysOfWeek[hours_todayIndex]], locale, locale === "en" ? "Open " : "Ouvert ")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "dropdown-menu bg-white w-100",
                        children: officeDaysOfWeek.map(function(day, index) {
                            return day !== "id" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: hours_todayIndex === index ? "sv-current-day" : "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "dropdown-item d-flex align-items-center justify-content-between py-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sv-hour-day",
                                                    style: {
                                                        fontWeight: hours_todayIndex === index ? "bold" : "normal"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "days.".concat(day)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sv-store-description ms-1",
                                                    children: hours_todayIndex === index && "(".concat(locale === "en" ? "Today" : "Aujourd'hui", ")")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sv-hour-time",
                                            children: officeHours[day] && (0,convertTimeFormat/* default */.Z)(officeHours[day], locale) || (locale === "en" ? "Closed" : "Ferm\xe9")
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var hours = (hours_Hours);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/components/store-locator/revamp/image-gallery/index.tsx









var ImageGallery = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38;
    var ref39 = (0,next_router.useRouter)(), locale = ref39.locale, asPath = ref39.asPath;
    var facilityData = props.facilityData;
    var initialImage = facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.Facility_Gallery) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.attributes;
    var ref40 = (0,react.useState)({
        url: (initialImage === null || initialImage === void 0 ? void 0 : initialImage.url) || "",
        alternativeText: (initialImage === null || initialImage === void 0 ? void 0 : initialImage.alternativeText) || ""
    }), selectedImage = ref40[0], setSelectedImage = ref40[1];
    var ref41 = (0,react.useState)(false), toggleVideo = ref41[0], setToggleVideo = ref41[1];
    var ref42 = (0,react.useState)(false), switchUrl = ref42[0], setSwitchUrl = ref42[1];
    var ref43 = (0,react.useState)(""), prevRoute = ref43[0], setPrevRoute = ref43[1];
    var ref44 = (0,react.useState)(true), isLoadingIframe = ref44[0], setIsLoadingIframe = ref44[1];
    var ref45 = (0,react.useState)(0), autoPlay = ref45[0], setAutoPlay = ref45[1];
    var ref46 = (0,react.useState)({
        videoHover: false,
        popupVideoHover: false
    }), hoverState = ref46[0], setHoverState = ref46[1];
    var ref47 = (0,react.useState)({
        mainVideo: false,
        popupVideo: false
    }), videoEnded = ref47[0], setVideoEnded = ref47[1];
    var handleVideoHover = function(type, state) {
        setHoverState(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, type, state));
        });
    };
    var handleVideoEnd = function(type) {
        setVideoEnded(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, type, true));
        });
    };
    var handleModalClose = function() {
        return setAutoPlay(0);
    };
    (0,react.useEffect)(function() {
        var switchLocale = JSON.parse(sessionStorage.getItem("switchLocale"));
        var currentUrl = {
            path: asPath,
            locale: locale,
            domain: "https://www.depotium.com",
            switchLocale: switchLocale
        };
        var preRoute = JSON.parse(sessionStorage.getItem("preRoute"));
        var getPreRoute = JSON.parse(sessionStorage.getItem("prevRoute"));
        var getUpdateRoute = JSON.parse(sessionStorage.getItem("updateRou"));
        if (getPreRoute && getPreRoute.locale === locale && (preRoute !== getUpdateRoute || !preRoute && !getUpdateRoute)) {
            setPrevRoute(getPreRoute.path);
            setSwitchUrl(false);
            sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
            sessionStorage.setItem("switchLocale", JSON.stringify(locale));
        } else {
            setSwitchUrl(true);
            if (preRoute && locale !== switchLocale) {
                var switchRou = preRoute.switchLocale, domain = preRoute.domain, path = preRoute.path, lng = preRoute.locale;
                var url = preRoute && switchRou ? "".concat(domain, "/").concat(switchRou).concat(path) : "".concat(domain, "/").concat(lng).concat(path);
                setPrevRoute(url);
                sessionStorage.setItem("updateRou", JSON.stringify(currentUrl));
                sessionStorage.setItem("prevRoute", null);
            } else if (getUpdateRoute && preRoute && preRoute !== getUpdateRoute) {
                var domain1 = getUpdateRoute.domain, path1 = getUpdateRoute.path, lng1 = getUpdateRoute.locale;
                var url1 = getUpdateRoute && getUpdateRoute.locale && "".concat(domain1, "/").concat(lng1).concat(path1);
                setPrevRoute(url1);
                sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
                sessionStorage.setItem("prevRoute", null);
            } else if (!preRoute && !getUpdateRoute && !getPreRoute) {
                setPrevRoute("".concat("https://www.depotium.com", "/").concat(locale).concat(asPath));
                sessionStorage.setItem("preRoute", JSON.stringify(currentUrl));
                sessionStorage.setItem("switchLocale", JSON.stringify(locale));
            } else {
                setPrevRoute("".concat("https://www.depotium.com", "/").concat(locale).concat(asPath));
            }
        }
        var handleEscKey = function(event) {
            if (event.key === "Escape") {
                var closeButton = document.querySelector('[data-bs-dismiss="modal"]');
                closeButton === null || closeButton === void 0 ? void 0 : closeButton.click();
                handleModalClose();
            }
        };
        document.addEventListener("keydown", handleEscKey);
        return function() {
            return document.removeEventListener("keydown", handleEscKey);
        };
    }, []);
    var renderImageOrVideo = function(image, index) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
        if (image === null || image === void 0 ? void 0 : (ref = image.Short_Video) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url) {
            var ref14, ref15, ref16;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-100 position-relative overflow-hidden sv-play-video-wrapper",
                onMouseEnter: function() {
                    return handleVideoHover("videoHover", true);
                },
                onMouseLeave: function() {
                    return handleVideoHover("videoHover", false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        width: "100%",
                        height: "100%",
                        style: {
                            objectFit: "cover"
                        },
                        controls: false,
                        autoPlay: true,
                        muted: true,
                        playsInline: true,
                        onEnded: function() {
                            return handleVideoEnd("mainVideo");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: image === null || image === void 0 ? void 0 : (ref14 = image.Short_Video) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.attributes) === null || ref16 === void 0 ? void 0 : ref16.url,
                            type: "video/mp4"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sv-images-overlayLayer ".concat(videoEnded.mainVideo || hoverState.videoHover ? "overlay-visible" : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sv-image-gallery-btns",
                        style: {
                            display: videoEnded.mainVideo || hoverState.videoHover ? "flex" : "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "sv-video-btn d-flex align-items-center",
                            onClick: function() {
                                setToggleVideo(true);
                                setIsLoadingIframe(true);
                                setAutoPlay(1);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sv-btn-icon me-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/sv-play-video-white-icon.svg",
                                        alt: locale === "en" ? "Play Video" : "Voir vid\xe9o"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "playVideo"
                                })
                            ]
                        })
                    })
                ]
            });
        }
        if (index === 4) {
            var ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
            var ref28;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-100 position-relative overflow-hidden sv-play-video-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, srcset((ref28 = image === null || image === void 0 ? void 0 : (ref17 = image.Image) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.data) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.attributes) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.formats) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.small) === null || ref21 === void 0 ? void 0 : ref21.url) !== null && ref28 !== void 0 ? ref28 : image === null || image === void 0 ? void 0 : (ref22 = image.Image) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.data) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.attributes) === null || ref24 === void 0 ? void 0 : ref24.url, 120, null, null)), {
                        alt: (image === null || image === void 0 ? void 0 : (ref25 = image.Image) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.data) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.attributes) === null || ref27 === void 0 ? void 0 : ref27.alternativeText) || "Facility image",
                        loading: "lazy"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sv-images-overlayLayer overlay-visible"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sv-image-gallery-btns",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "sv-img-btn d-flex align-items-center",
                            "aria-label": locale === "en" ? "10+ Photos" : "Photos 10+",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#extraImagesModal",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sv-btn-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/sv-images-icon.svg",
                                        alt: "Images"
                                    })
                                }),
                                locale === "en" ? "10+ Photos" : "Photos 10+"
                            ]
                        })
                    })
                ]
            });
        }
        var ref29;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, srcset((ref29 = image === null || image === void 0 ? void 0 : (ref3 = image.Image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.formats) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[index === 0 ? "medium" : "small"]) === null || ref7 === void 0 ? void 0 : ref7.url) !== null && ref29 !== void 0 ? ref29 : image === null || image === void 0 ? void 0 : (ref8 = image.Image) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.attributes) === null || ref10 === void 0 ? void 0 : ref10.url, 120, null, null)), {
            alt: (image === null || image === void 0 ? void 0 : (ref11 = image.Image) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.attributes) === null || ref13 === void 0 ? void 0 : ref13.alternativeText) || "Facility image",
            loading: "lazy"
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sv-storage-image-gallery",
        children: [
            (facilityData === null || facilityData === void 0 ? void 0 : (ref5 = facilityData.attributes) === null || ref5 === void 0 ? void 0 : ref5.Facility_Gallery) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "images overflow-hidden",
                children: facilityData === null || facilityData === void 0 ? void 0 : (ref6 = facilityData.attributes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Facility_Gallery) === null || ref7 === void 0 ? void 0 : ref7.slice(1, 6).map(function(image, index) {
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "img-item position-relative",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#extraImagesModal",
                        onClick: function() {
                            if (index === 3) {
                                setToggleVideo(true);
                                setIsLoadingIframe(true);
                                setAutoPlay(1);
                            } else {
                                var ref, ref1;
                                setSelectedImage(image === null || image === void 0 ? void 0 : (ref = image.Image) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.attributes);
                                setToggleVideo(false);
                                setAutoPlay(0);
                            }
                        },
                        children: [
                            renderImageOrVideo(image, index),
                            index === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: !(image === null || image === void 0 ? void 0 : (ref = image.Short_Video) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sv-overlay-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sv-images-overlayLayer"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sv-image-gallery-btns sv-image-video-play",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "btn sv-play-video-btn position-absolute center-button z-index-2",
                                                onClick: function(e) {
                                                    e.stopPropagation();
                                                    setToggleVideo(true);
                                                    setIsLoadingIframe(true);
                                                    setAutoPlay(1);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sv-btn-icon me-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/sv-play-video-white-icon.svg",
                                                            alt: locale === "en" ? "Play Video" : "Voir vid\xe9o"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "playVideo"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }, (image === null || image === void 0 ? void 0 : (ref3 = image.Image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.url) || index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sv-image-gallery-btns top-0",
                children: !switchUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: prevRoute,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "btn sv-back-btn",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sv-btn-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/sv-back-btn-arrow.svg",
                                    alt: "Back Arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "back"
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "btn sv-back-btn",
                    onClick: function() {
                        window.location.href = prevRoute;
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sv-btn-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/sv-back-btn-arrow.svg",
                                alt: "Back Arrow"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "back"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal fade",
                id: "extraImagesModal",
                role: "dialog",
                "aria-labelledby": "extraImagesModalLabel",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-dialog modal-dialog-centered container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal-header",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn-close sv-close-btn",
                                    "data-bs-dismiss": "modal",
                                    "aria-label": "Close",
                                    onClick: handleModalClose,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/sv-modal-cross-icon.svg",
                                        alt: "Cross icon"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal-body",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row p-0 m-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-9 px-2",
                                            id: "big-image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "position-relative h-100 ratio ratio-3x2",
                                                children: toggleVideo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        isLoadingIframe && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle",
                                                            style: {
                                                                width: "100%",
                                                                height: "100%",
                                                                zIndex: 2
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "spinner-border text-light",
                                                                style: {
                                                                    width: "4rem",
                                                                    height: "4rem"
                                                                },
                                                                role: "status",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "visually-hidden",
                                                                    children: "Loading..."
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                            style: {
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                width: "100%",
                                                                height: "100%",
                                                                borderRadius: "8px",
                                                                transform: "translateZ(0px)",
                                                                zIndex: 1
                                                            },
                                                            src: "".concat(facilityData === null || facilityData === void 0 ? void 0 : (ref8 = facilityData.attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Facility_Gallery) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.Video_URL, "?autoplay=").concat(autoPlay, "&muted=1&controls=1&loop=0"),
                                                            onLoad: function() {
                                                                return setIsLoadingIframe(false);
                                                            },
                                                            loading: "lazy",
                                                            allow: "autoplay; fullscreen"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    className: "w-100 h-100",
                                                    style: {
                                                        objectFit: "cover",
                                                        borderRadius: "8px"
                                                    }
                                                }, srcset(selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.url, 320, null, null)), {
                                                    alt: selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.alternativeText,
                                                    loading: "lazy"
                                                }))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-3 p-0",
                                            children: [
                                                (facilityData === null || facilityData === void 0 ? void 0 : (ref11 = facilityData.attributes) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Facility_Gallery) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[4]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Short_Video) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.attributes) === null || ref16 === void 0 ? void 0 : ref16.url) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "position-relative ".concat(toggleVideo ? "d-none" : ""),
                                                    style: {
                                                        height: "173px",
                                                        marginBottom: "7px"
                                                    },
                                                    onMouseEnter: function() {
                                                        return handleVideoHover("popupVideoHover", true);
                                                    },
                                                    onMouseLeave: function() {
                                                        return handleVideoHover("popupVideoHover", false);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                                            width: "100%",
                                                            className: "sv-modal-play-video",
                                                            height: "100%",
                                                            style: {
                                                                objectFit: "cover",
                                                                borderRadius: "12px"
                                                            },
                                                            controls: false,
                                                            autoPlay: true,
                                                            muted: true,
                                                            playsInline: true,
                                                            onEnded: function() {
                                                                return handleVideoEnd("popupVideo");
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                                src: facilityData === null || facilityData === void 0 ? void 0 : (ref17 = facilityData.attributes) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.Facility_Gallery) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[4]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.Short_Video) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.data) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.attributes) === null || ref22 === void 0 ? void 0 : ref22.url,
                                                                type: "video/mp4"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                display: videoEnded.popupVideo || hoverState.popupVideoHover ? "flex" : "none"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "sv-images-overlayLayer sv-modal-play-video"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                    className: "btn sv-play-video-btn position-absolute center-button z-index-1",
                                                                    onClick: function() {
                                                                        setToggleVideo(true);
                                                                        setIsLoadingIframe(true);
                                                                        setAutoPlay(1);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "sv-btn-icon me-1",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: "/images/sv-play-video-white-icon.svg",
                                                                                alt: locale === "en" ? "Play Video" : "Voir vid\xe9o"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                            id: "playVideo"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "position-relative ".concat(toggleVideo ? "d-none" : ""),
                                                    style: {
                                                        height: "173px",
                                                        marginBottom: "7px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            className: "sv-modal-play-video",
                                                            style: {
                                                                height: "173px",
                                                                width: "100%",
                                                                marginBottom: "7px",
                                                                objectFit: "cover",
                                                                borderRadius: "12px"
                                                            }
                                                        }, srcset(facilityData === null || facilityData === void 0 ? void 0 : (ref23 = facilityData.attributes) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.Facility_Gallery) === null || ref24 === void 0 ? void 0 : (ref25 = ref24[4]) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.Image) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.data) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.attributes) === null || ref28 === void 0 ? void 0 : ref28.url, 320, null, null)), {
                                                            alt: facilityData === null || facilityData === void 0 ? void 0 : (ref29 = facilityData.attributes) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.Facility_Gallery) === null || ref30 === void 0 ? void 0 : (ref31 = ref30[4]) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.Image) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.data) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.attributes) === null || ref34 === void 0 ? void 0 : ref34.alternativeText,
                                                            loading: "lazy"
                                                        })),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "sv-overlay-container",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "sv-images-overlayLayer sv-modal-play-video"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                    className: "btn sv-play-video-btn position-absolute center-button z-index-2",
                                                                    onClick: function() {
                                                                        setToggleVideo(true);
                                                                        setIsLoadingIframe(true);
                                                                        setAutoPlay(1);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "sv-btn-icon me-1",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: "/images/sv-play-video-white-icon.svg",
                                                                                alt: locale === "en" ? "Play Video" : "Voir vid\xe9o"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                            id: "playVideo"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "img-scroll-container position-relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "img-scroll",
                                                            style: {
                                                                height: toggleVideo ? "590px" : "410px"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "me-2",
                                                                children: facilityData === null || facilityData === void 0 ? void 0 : (ref35 = facilityData.attributes) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.Facility_Gallery) === null || ref36 === void 0 ? void 0 : ref36.slice(1, facilityData === null || facilityData === void 0 ? void 0 : (ref37 = facilityData.attributes) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.Facility_Gallery) === null || ref38 === void 0 ? void 0 : ref38.length).map(function(image, index) {
                                                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                        className: "small-images"
                                                                    }, srcset(image === null || image === void 0 ? void 0 : (ref = image.Image) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url, 200, null, null)), {
                                                                        onClick: function() {
                                                                            var ref, ref1;
                                                                            setSelectedImage(image === null || image === void 0 ? void 0 : (ref = image.Image) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.attributes);
                                                                            setToggleVideo(false);
                                                                        },
                                                                        alt: image === null || image === void 0 ? void 0 : (ref3 = image.Image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.alternativeText,
                                                                        loading: "lazy"
                                                                    }), (image === null || image === void 0 ? void 0 : (ref6 = image.Image) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.attributes) === null || ref8 === void 0 ? void 0 : ref8.url) || index);
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "overlay-top"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "overlay-bottom"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var image_gallery = (ImageGallery);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/buttons/size-help/index.tsx + 1 modules
var size_help = __webpack_require__(65732);
;// CONCATENATED MODULE: ./public/images/icons/settings-04.svg
/* harmony default export */ var settings_04 = ({"src":"/_next/static/media/settings-04.f3619592.svg","height":24,"width":25});
// EXTERNAL MODULE: ./src/components/buttons/unit-filter/style.module.scss
var style_module = __webpack_require__(8586);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/buttons/unit-filter/index.tsx




var UnitFilterButton = function(props) {
    var hasFilter = props.hasFilter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (style_module_default()).sizeHelpBtnContainer,
        "data-bs-toggle": "modal",
        "data-bs-target": "#SvFilterModalUnit",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: settings_04.src,
                alt: "info-icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "filter"
                })
            }),
            !hasFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).filterDot
            })
        ]
    });
};
/* harmony default export */ var unit_filter = (UnitFilterButton);

// EXTERNAL MODULE: ./src/helper/filterlogicInfo.tsx
var filterlogicInfo = __webpack_require__(18711);
// EXTERNAL MODULE: ./src/components/callback-modal/requestcallback-modal.tsx + 2 modules
var requestcallback_modal = __webpack_require__(44223);
// EXTERNAL MODULE: ./src/components/store-locator/loading.tsx + 2 modules
var loading = __webpack_require__(15931);
;// CONCATENATED MODULE: ./src/components/store-locator/no-units-facility.tsx



var NoUnitsFacility = function(props) {
    var onCheckBoxClick = props.onCheckBoxClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tab-pane active show",
        id: "reset-filters",
        role: "tabpanel",
        "aria-labelledby": "reset-filters-tab",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container text-lt-md-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    className: "sub-heading mt-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "no-units-found-facility"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "para",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "do-reset-filters"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "no-units-btn",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn primary-card-btn",
                            type: "button",
                            onClick: function() {
                                return onCheckBoxClick({
                                    target: {
                                        value: "Featured",
                                        checked: true
                                    }
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "reset-filters"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "#self-storage",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn secondary-card-btn",
                                type: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "find-near-by-location"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var no_units_facility = (NoUnitsFacility);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 36 modules
var Modal = __webpack_require__(61909);
// EXTERNAL MODULE: ./src/components/dropdowns/unit-promotions/index.tsx
var unit_promotions = __webpack_require__(19399);
// EXTERNAL MODULE: ./src/helper/formatAsPrice.tsx
var formatAsPrice = __webpack_require__(38131);
// EXTERNAL MODULE: ./public/images/icons/phone-incoming-01.svg
var phone_incoming_01 = __webpack_require__(70095);
// EXTERNAL MODULE: ./public/images/icons/play-icon.svg
var play_icon = __webpack_require__(25797);
// EXTERNAL MODULE: ./src/components/store-locator/store.module.scss
var store_module = __webpack_require__(89978);
var store_module_default = /*#__PURE__*/__webpack_require__.n(store_module);
;// CONCATENATED MODULE: ./src/components/store-locator/single-unit-card.tsx













var SingleUnitCard = function(props) {
    var ref, ref1, ref2, ref3;
    var item = props.item, showDimensions = props.showDimensions;
    var ref4 = (0,react.useState)(false), show = ref4[0], setShow = ref4[1];
    var ref5 = (0,react.useState)(null), selectedPromotion = ref5[0], setSelectedPromotion = ref5[1];
    var ref6 = (0,react.useState)(false), promotionError = ref6[0], setPromotionError = ref6[1];
    var ref7 = (0,react.useState)(null), toggle = ref7[0], setToggle = ref7[1];
    var ref8 = (0,react.useState)(null), target = ref8[0], setTarget = ref8[1];
    var ref9 = (0,react.useState)(null), displayPromotion = ref9[0], setDisplayPromotion = ref9[1];
    var promotionList = item === null || item === void 0 ? void 0 : item.promotionList;
    var handleClose = function() {
        return setShow(false);
    };
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var locale = (0,next_router.useRouter)().locale;
    var facilityId = headerFooterData.facilityId;
    var handleShow = function() {
        setShow(true);
    };
    var handleCeiling = function() {
        if (facilityId === "L086") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "filters.2ftceiling"
            });
        }
        if (facilityId === "L030" || facilityId === "L022") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "filters.3ftceiling"
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "filters.4ftceiling"
        });
    };
    var handlePromotionSelect = function(promotion) {
        setSelectedPromotion(promotion);
        setPromotionError(false);
        setTarget("#requestCallbackModal");
        setToggle("modal");
        if (promotion) {
            var rate = item === null || item === void 0 ? void 0 : item.rate;
            var tempPromotionRate = rate - rate * promotion.discount / 100;
            setDisplayPromotion((0,formatAsPrice/* formatAsPrice */.n)(tempPromotionRate, locale, false));
        }
    };
    var handleClick = function(event, facility, formType) {
        var ref, ref1, ref2, ref3;
        if (!selectedPromotion) {
            event.preventDefault();
            setPromotionError(true);
            return;
        }
        var obj = {
            unitRate: facility.rate,
            dimensions: "".concat(facility === null || facility === void 0 ? void 0 : (ref = facility.dimensions) === null || ref === void 0 ? void 0 : ref.width, " x ").concat(facility === null || facility === void 0 ? void 0 : (ref1 = facility.dimensions) === null || ref1 === void 0 ? void 0 : ref1.length),
            facilityID: headerFooterData.facilityId,
            unitTypeId: facility.unitTypeId,
            PromotionSLName: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.slName,
            promotionDescription: locale === "fr" ? selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.fr : selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.en,
            consessionId: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.concessionID,
            unitWidth: facility === null || facility === void 0 ? void 0 : (ref2 = facility.dimensions) === null || ref2 === void 0 ? void 0 : ref2.width,
            unitLength: facility === null || facility === void 0 ? void 0 : (ref3 = facility.dimensions) === null || ref3 === void 0 ? void 0 : ref3.length,
            formType: formType
        };
        headerFooterData.setViewUnit(obj);
    };
    var UnitFeatures = function() {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (store_module_default()).unitFeatures,
            children: [
                (item === null || item === void 0 ? void 0 : (ref = item.hasAmenities) === null || ref === void 0 ? void 0 : ref.miniLocker) ? handleCeiling() : "",
                (item === null || item === void 0 ? void 0 : (ref1 = item.hasAmenities) === null || ref1 === void 0 ? void 0 : ref1.heated) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "filters.heated"
                    })
                }) : "",
                " ",
                (item === null || item === void 0 ? void 0 : (ref2 = item.hasAmenities) === null || ref2 === void 0 ? void 0 : ref2.driveUp) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "filters.driveup"
                    })
                }) : "",
                (item === null || item === void 0 ? void 0 : (ref3 = item.hasAmenities) === null || ref3 === void 0 ? void 0 : ref3.climateControlled) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "filters.climateControlled"
                    })
                }) : ""
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (store_module_default()).unitContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (store_module_default()).imageContainer,
                        children: [
                            item.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item === null || item === void 0 ? void 0 : item.image,
                                alt: "Unit image",
                                className: "".concat((store_module_default()).unitImage)
                            }),
                            (item === null || item === void 0 ? void 0 : item.videoUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: play_icon/* default */.Z || "",
                                alt: "play",
                                width: "25",
                                height: "25",
                                onClick: handleShow,
                                className: "".concat((store_module_default()).unitVideoPlay)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (store_module_default()).detailsContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (store_module_default()).unitFeaturesContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (store_module_default()).unitDetails,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (store_module_default()).unitDimensions,
                                                children: showDimensions ? "" : (item === null || item === void 0 ? void 0 : (ref = item.dimensions) === null || ref === void 0 ? void 0 : ref.width) && (item === null || item === void 0 ? void 0 : (ref1 = item.dimensions) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        item === null || item === void 0 ? void 0 : (ref2 = item.dimensions) === null || ref2 === void 0 ? void 0 : ref2.width,
                                                        locale === "en" && "’",
                                                        " x ",
                                                        item === null || item === void 0 ? void 0 : (ref3 = item.dimensions) === null || ref3 === void 0 ? void 0 : ref3.length,
                                                        locale === "en" && "’"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnitFeatures, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (store_module_default()).unitPrice,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (store_module_default()).unitPriceText,
                                                children: displayPromotion || (0,formatAsPrice/* formatAsPrice */.n)(item === null || item === void 0 ? void 0 : item.rate, locale, false)
                                            }),
                                            (item === null || item === void 0 ? void 0 : item.rate) && displayPromotion && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "sv-dark-grey-medium-regular-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("del", {
                                                    children: (0,formatAsPrice/* formatAsPrice */.n)(item === null || item === void 0 ? void 0 : item.rate, locale, false)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sv-dark-grey-small-regular-text text-nowrap",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "per week"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (store_module_default()).unitReservationContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnitFeatures, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (store_module_default()).unitControllers,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (store_module_default()).unitPromotionDropdown,
                                                children: promotionList && promotionList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_promotions/* default */.Z, {
                                                    unit: item,
                                                    promotionError: promotionError,
                                                    locale: locale,
                                                    onSelect: handlePromotionSelect,
                                                    isMultiPromo: promotionList.length > 1
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (store_module_default()).unitCallback,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    "data-bs-toggle": toggle,
                                                    "data-bs-target": target,
                                                    className: "btn dp-secondary-btn dp-secondary-btn-white",
                                                    type: "button",
                                                    onClick: function(event) {
                                                        return handleClick(event, item, "callmeback");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: phone_incoming_01/* default */.Z,
                                                        alt: "call-back",
                                                        width: "28",
                                                        height: "28"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (store_module_default()).unitReservationBtn,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    "data-bs-toggle": toggle,
                                                    "data-bs-target": target,
                                                    className: "btn dp-primary-btn w-100 d-flex justify-content-center gap-2",
                                                    type: "button",
                                                    onClick: function(event) {
                                                        return handleClick(event, item, "reserve");
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "facility-reserve"
                                                        }),
                                                        !!(item === null || item === void 0 ? void 0 : item.numAvailable) && constants/* MINIMUM_UNITS */.d7 < (item === null || item === void 0 ? void 0 : item.numAvailable) && (item === null || item === void 0 ? void 0 : item.numAvailable) < constants/* UNITS_LEFT */.xt && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "sv-red-small-text",
                                                            children: [
                                                                item === null || item === void 0 ? void 0 : item.numAvailable,
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "Units-left"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: show,
                onHide: handleClose,
                id: "unitVideoModal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                        children: (item === null || item === void 0 ? void 0 : item.videoUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            src: item === null || item === void 0 ? void 0 : item.videoUrl,
                            width: "775",
                            height: "435"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            sizes: "(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 700px, (max-width: 992px) 700px, (max-width: 1280px) 700px",
                            src: item === null || item === void 0 ? void 0 : item.image,
                            alt: "logo",
                            className: "img-fluid thumbnail",
                            width: "180",
                            height: "180"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var single_unit_card = (SingleUnitCard);

;// CONCATENATED MODULE: ./src/components/store-locator/outdoor-units.tsx



var OutdoorUnits = function(props) {
    var parkingUnitsData = props.parkingUnitsData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: parkingUnitsData && (parkingUnitsData === null || parkingUnitsData === void 0 ? void 0 : parkingUnitsData.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "sv-units-details",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-between",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-auto col-md-auto col-sm-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "units-size-titles",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "filters.outdoorParking"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "unit-details-table",
                    children: parkingUnitsData && parkingUnitsData.length && parkingUnitsData.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_unit_card, {
                            showDimensions: true,
                            item: item
                        }, index);
                    })
                })
            ]
        }) : null
    });
};
/* harmony default export */ var outdoor_units = (OutdoorUnits);

// EXTERNAL MODULE: ./public/images/icons/minus.svg
var minus = __webpack_require__(2620);
// EXTERNAL MODULE: ./public/images/icons/plus.svg
var plus = __webpack_require__(41611);
;// CONCATENATED MODULE: ./src/components/store-locator/unit-section.tsx







var UnitSection = function(props) {
    var unitsData = props.unitsData, unitsHeading = props.unitsHeading, checkName = props.checkName, featuredChecked = props.featuredChecked, onCheckBoxClick = props.onCheckBoxClick, unitsSubHeading = props.unitsSubHeading;
    var filteredUnits = (0,filterlogicInfo/* fiterWithSize */.vd)(unitsData);
    var popularUnits = (0,filterlogicInfo/* isPopularData */.eU)(filteredUnits);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: filteredUnits && (filteredUnits === null || filteredUnits === void 0 ? void 0 : filteredUnits.length) && (featuredChecked && popularUnits.length || !featuredChecked) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "sv-units-details",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row justify-content-between align-items-center title-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-lg-auto col-md-auto col-sm-12 d-flex gap-1 align-items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "units-size-titles",
                                    children: unitsHeading
                                }),
                                unitsSubHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "units-size-subtitles",
                                    children: unitsSubHeading
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-auto col-md-auto col-sm-12 text-end"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "unit-details-table",
                    children: filteredUnits && filteredUnits.length && popularUnits && (!featuredChecked ? filteredUnits.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_unit_card, {
                            item: item
                        }, index);
                    }) : popularUnits === null || popularUnits === void 0 ? void 0 : popularUnits.slice(0, 2).map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_unit_card, {
                            item: item
                        }, index);
                    }))
                }),
                featuredChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-auto col-md-auto col-sm-12 text-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: function() {
                            return onCheckBoxClick({
                                target: {
                                    value: checkName,
                                    checked: true
                                }
                            });
                        },
                        className: "expand-list-btn",
                        value: checkName,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "buttons.seeMore"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: plus/* default */.Z,
                                alt: "plus-icon",
                                className: "plus-icon",
                                width: "30",
                                height: "30"
                            })
                        ]
                    })
                }),
                !featuredChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-auto col-md-auto col-sm-12 text-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: function() {
                            return onCheckBoxClick({
                                target: {
                                    value: "Featured",
                                    checked: true
                                }
                            });
                        },
                        className: "expand-list-btn",
                        value: checkName,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "buttons.less"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: minus/* default */.Z,
                                alt: "minus-icon",
                                className: "plus-icon",
                                width: "30",
                                height: "30"
                            })
                        ]
                    })
                })
            ]
        }) : null
    });
};
/* harmony default export */ var unit_section = (UnitSection);

;// CONCATENATED MODULE: ./src/components/store-locator/units-filter.tsx
















var ShopSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4452).then(__webpack_require__.bind(__webpack_require__, 74452));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74452)
            ];
        }
    }
});
var UnitFilterCard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4908).then(__webpack_require__.bind(__webpack_require__, 14908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14908)
            ];
        }
    }
});
var UnitFilterPop = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59925));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59925)
            ];
        }
    }
});
var UnitsFilter = function(props) {
    var ref, ref1;
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var brandRelatedData = props.brandRelatedData, uniqueUnitTypes = props.uniqueUnitTypes, UnitsData = props.UnitsData;
    var ref2 = (0,react.useState)(false), featuredChecked = ref2[0], setfeaturedChecked = ref2[1];
    var ref3 = (0,react.useState)(false), smallChecked = ref3[0], setsmallChecked = ref3[1];
    var ref4 = (0,react.useState)(false), mediumChecked = ref4[0], setmediumChecked = ref4[1];
    var ref5 = (0,react.useState)(false), largeChecked = ref5[0], setlargeChecked = ref5[1];
    var ref6 = (0,react.useState)(false), heatedChecked = ref6[0], setHeatedChecked = ref6[1];
    var ref7 = (0,react.useState)(false), climateControlledChecked = ref7[0], setClimateControlledChecked = ref7[1];
    var ref8 = (0,react.useState)(false), driveupChecked = ref8[0], setDriveUpChecked = ref8[1];
    var ref9 = (0,react.useState)(false), parkingChecked = ref9[0], setParkingChecked = ref9[1];
    var ref10 = (0,react.useState)(false), indoorcarChecked = ref10[0], setindoorcarChecked = ref10[1];
    var ref11 = (0,react.useState)(false), xlargeChecked = ref11[0], setXlargeChecked = ref11[1];
    var ref12 = (0,react.useState)(false), officeChecked = ref12[0], setOfficeChecked = ref12[1];
    var ref13 = (0,react.useState)([]), smallUnitsData = ref13[0], setsmallUnitsData = ref13[1];
    var ref14 = (0,react.useState)([]), mailboxUnitsData = ref14[0], setMailboxUnitsData = ref14[1];
    var ref15 = (0,react.useState)([]), largeUnitsData = ref15[0], setlargeUnitsData = ref15[1];
    var ref16 = (0,react.useState)([]), mediumUnitsData = ref16[0], setmediumUnitsData = ref16[1];
    var ref17 = (0,react.useState)([]), xLargeUnitsData = ref17[0], setxLargeUnitsData = ref17[1];
    var ref18 = (0,react.useState)([]), parkingUnitsData = ref18[0], setparkingUnitsData = ref18[1];
    var ref19 = (0,react.useState)([]), officeUnitsData = ref19[0], setofficeUnitsData = ref19[1];
    var ref20 = (0,react.useState)([]), featurefilterData = ref20[0], setfeaturefilterData = ref20[1];
    var ref21 = (0,react.useState)([]), filteredData = ref21[0], setFilteredData = ref21[1];
    var ref22 = (0,react.useState)([]), finalData = ref22[0], setFinalData = ref22[1];
    var ref23 = (0,react.useState)(false), indoorcarBlur = ref23[0], setindoorcarBlur = ref23[1];
    var ref24 = (0,react.useState)(false), nothingChecked = ref24[0], setNothingChecked = ref24[1];
    var ref25 = (0,react.useState)(true), facilityLoader = ref25[0], setFacilityLoader = ref25[1];
    var ref26 = (0,react.useState)(false), filterDot = ref26[0], setFilterDot = ref26[1];
    var parkingBlur = !(0,filterlogicInfo/* isParking */.iI)(UnitsData);
    var unitInfo = headerFooterData.viewUnitInfo;
    var facilityId = unitInfo.facilityID ? unitInfo.facilityID : constants/* DEFAULT_FACILITY_ID */.MS;
    (0,react.useEffect)(function() {
        setsmallChecked(false);
        setmediumChecked(false);
        setlargeChecked(false);
        setHeatedChecked(false);
        setDriveUpChecked(false);
        setClimateControlledChecked(false);
        setParkingChecked(false);
        setindoorcarChecked(false);
        setXlargeChecked(false);
        setOfficeChecked(false);
    }, [
        props
    ]);
    (0,react.useEffect)(function() {
        setfeaturedChecked(true);
        setfeaturefilterData((0,filterlogicInfo/* featuredData */.u5)(UnitsData));
        setFinalData((0,filterlogicInfo/* featuredData */.u5)(UnitsData));
        setindoorcarBlur(!(0,filterlogicInfo/* hasIndoorParkingUnits */.RE)(UnitsData));
    }, [
        UnitsData
    ]);
    (0,react.useEffect)(function() {
        var smallUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "Small");
        var largeUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "Large");
        var mediumUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "Medium");
        var officeUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "office");
        var xLargeUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "xLarge");
        var outdoorUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "parking");
        var mailUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "mailbox");
        setsmallUnitsData(smallUnits);
        setlargeUnitsData(largeUnits);
        setmediumUnitsData(mediumUnits);
        setxLargeUnitsData(xLargeUnits);
        setparkingUnitsData(outdoorUnits);
        setofficeUnitsData(officeUnits);
        setMailboxUnitsData(mailUnits);
        if (finalData && finalData.length || (UnitsData === null || UnitsData === void 0 ? void 0 : UnitsData.length) === 0) {
            setFacilityLoader(false);
        }
    }, [
        finalData
    ]);
    (0,react.useEffect)(function() {
        if (smallChecked || mediumChecked || largeChecked || parkingChecked || indoorcarChecked || xlargeChecked || officeChecked || featuredChecked || heatedChecked || driveupChecked || climateControlledChecked) {
            setFilterDot(true);
        } else {
            setFilterDot(false);
        }
        if (!smallChecked && !mediumChecked && !largeChecked && !parkingChecked && !indoorcarChecked && !xlargeChecked && !officeChecked && !featuredChecked) {
            setNothingChecked(true);
            setFinalData((0,filterlogicInfo/* filterUnitsDataByfeatures */.IF)(UnitsData, heatedChecked, driveupChecked, climateControlledChecked));
        } else if (featuredChecked) {
            setNothingChecked(false);
            setFinalData((0,filterlogicInfo/* filterUnitsDataByfeatures */.IF)(featurefilterData, heatedChecked, driveupChecked, climateControlledChecked));
        } else if (smallChecked || mediumChecked || largeChecked || parkingChecked || indoorcarChecked || xlargeChecked || officeChecked) {
            setNothingChecked(false);
            setFinalData((0,filterlogicInfo/* filterUnitsDataByfeatures */.IF)(filteredData, heatedChecked, driveupChecked, climateControlledChecked));
        }
        if (heatedChecked || driveupChecked || climateControlledChecked) {
            setfeaturedChecked(false);
        }
    }, [
        smallChecked,
        mediumChecked,
        largeChecked,
        parkingChecked,
        xlargeChecked,
        officeChecked,
        featuredChecked,
        heatedChecked,
        driveupChecked,
        indoorcarChecked,
        climateControlledChecked, 
    ]);
    var onCheckBoxClick = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        if (value === "Featured") {
            setfeaturedChecked(!featuredChecked);
            setsmallChecked(false);
            setlargeChecked(false);
            setmediumChecked(false);
            setXlargeChecked(false);
            setParkingChecked(false);
            setindoorcarChecked(false);
            setHeatedChecked(false);
            setClimateControlledChecked(false);
            setOfficeChecked(false);
            setDriveUpChecked(false);
        }
        if (value === "Small") {
            setsmallChecked(!smallChecked);
            setfeaturedChecked(false);
        }
        if (value === "Medium") {
            setmediumChecked(!mediumChecked);
            setfeaturedChecked(false);
        }
        if (value === "Large") {
            setlargeChecked(!largeChecked);
            setfeaturedChecked(false);
        }
        if (value === "heated") {
            setHeatedChecked(!heatedChecked);
            setClimateControlledChecked(false);
        }
        if (value === "climateControlled") {
            setClimateControlledChecked(!climateControlledChecked);
            setHeatedChecked(false);
        }
        if (value === "driveUp") {
            setDriveUpChecked(!driveupChecked);
        }
        if (value === "xLarge") {
            setfeaturedChecked(false);
            setXlargeChecked(!xlargeChecked);
        }
        if (value === "parking") {
            setfeaturedChecked(false);
            setParkingChecked(!parkingChecked);
        }
        if (value === "indoorcar") {
            setfeaturedChecked(false);
            setsmallChecked(false);
            setlargeChecked(false);
            setmediumChecked(false);
            setXlargeChecked(false);
            setClimateControlledChecked(false);
            setHeatedChecked(false);
            setOfficeChecked(false);
            setDriveUpChecked(false);
            setindoorcarChecked(!indoorcarChecked);
        }
        if (value === "office") {
            setfeaturedChecked(false);
            setOfficeChecked(!officeChecked);
        }
        if (value === "clear") {
            setfeaturedChecked(false);
            setsmallChecked(false);
            setlargeChecked(false);
            setmediumChecked(false);
            setXlargeChecked(false);
            setParkingChecked(false);
            setindoorcarChecked(false);
            setOfficeChecked(false);
            setDriveUpChecked(false);
            setHeatedChecked(false);
            setClimateControlledChecked(false);
            setFilteredData(UnitsData);
        }
        if (value === "Featured" && checked === true) {
            setfeaturefilterData((0,filterlogicInfo/* featuredData */.u5)(UnitsData));
            setFilteredData([]);
        } else if (featuredChecked === false) {
            setfeaturefilterData([]);
        }
        if (value === "Small" || value === "Medium" || value === "Large" || value === "xLarge" || value === "parking" || value === "office") {
            if (checked) {
                if (indoorcarChecked && value !== "parking") {
                    // remove indoor car storage filter and add the selected filter
                    var updatedUnits = (0,filterlogicInfo/* removeIndoorParkingUnitsData */.uB)(filteredData);
                    setindoorcarChecked(false);
                    setFilteredData((0,_to_consumable_array/* default */.Z)(updatedUnits).concat((0,_to_consumable_array/* default */.Z)((0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(UnitsData, value))));
                } else if (indoorcarChecked && parkingChecked) {
                    // remove all filters except parking and add the selected filter
                    setindoorcarChecked(false);
                    setDriveUpChecked(false);
                    setHeatedChecked(false);
                    setClimateControlledChecked(false);
                    var parking = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(UnitsData, "parking");
                    setFilteredData((0,_to_consumable_array/* default */.Z)(parking).concat((0,_to_consumable_array/* default */.Z)((0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(UnitsData, value))));
                } else {
                    // add selected filter
                    setFilteredData((0,_to_consumable_array/* default */.Z)(filteredData).concat((0,_to_consumable_array/* default */.Z)((0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(UnitsData, value))));
                }
            } else {
                setFilteredData((0,filterlogicInfo/* removeUnitsDataWithSize */.Sy)(filteredData, value));
            }
        }
        if (value === "indoorcar") {
            if (checked) {
                // reset filteredData
                var indoor = (0,filterlogicInfo/* isIndoorParking */.Mt)(UnitsData);
                if (parkingChecked) {
                    setFilteredData((0,_to_consumable_array/* default */.Z)(indoor).concat((0,_to_consumable_array/* default */.Z)((0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(UnitsData, "parking"))));
                } else {
                    setFilteredData(indoor);
                }
            } else {
                setFilteredData((0,filterlogicInfo/* removeIndoorParkingUnitsData */.uB)(filteredData));
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "sv-filter-size-guide-responsive d-lg-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_filter, {
                                    hasFilter: !filterDot
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 col-12"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(size_help/* default */.Z, {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !facilityLoader ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row gx-3 reverse-flex visible-md",
                            style: {
                                marginTop: "12px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-lg-3 col-md-12 col-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnitFilterCard, {
                                            onCheckBoxClick: onCheckBoxClick,
                                            featuredChecked: featuredChecked,
                                            smallChecked: smallChecked,
                                            mediumChecked: mediumChecked,
                                            largeChecked: largeChecked,
                                            heatedChecked: heatedChecked,
                                            climateControlledChecked: climateControlledChecked,
                                            driveupChecked: driveupChecked,
                                            parkingChecked: parkingChecked,
                                            indoorcarChecked: indoorcarChecked,
                                            xlargeChecked: xlargeChecked,
                                            officeChecked: officeChecked,
                                            uniqueUnitTypes: uniqueUnitTypes,
                                            parkingBlur: parkingBlur,
                                            indoorcarBlur: indoorcarBlur
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopSection, {
                                            shopStore: brandRelatedData === null || brandRelatedData === void 0 ? void 0 : brandRelatedData.Shop_Store
                                        }),
                                        finalData && (finalData === null || finalData === void 0 ? void 0 : finalData.length) && (brandRelatedData === null || brandRelatedData === void 0 ? void 0 : (ref = brandRelatedData.Shop_Store) === null || ref === void 0 ? void 0 : ref.Description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "card-content",
                                            dangerouslySetInnerHTML: {
                                                __html: browser_default().sanitize(brandRelatedData === null || brandRelatedData === void 0 ? void 0 : (ref1 = brandRelatedData.Shop_Store) === null || ref1 === void 0 ? void 0 : ref1.Description)
                                            }
                                        }) : ""
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-lg-9 col-md-12 col-12 px-0",
                                    children: finalData && (finalData === null || finalData === void 0 ? void 0 : finalData.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            smallUnitsData && (smallChecked || featuredChecked || nothingChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_section, {
                                                unitsHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "sectionName.small"
                                                }),
                                                checkName: "Small",
                                                unitsData: smallUnitsData,
                                                featuredChecked: featuredChecked,
                                                onCheckBoxClick: onCheckBoxClick,
                                                heatedChecked: heatedChecked,
                                                climateControlledChecked: climateControlledChecked,
                                                driveupChecked: driveupChecked,
                                                unitsSubHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "sectionName.small.info"
                                                })
                                            }),
                                            mediumUnitsData && (mediumChecked || featuredChecked || indoorcarChecked || nothingChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_section, {
                                                checkName: "Medium",
                                                unitsHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "sectionName.medium"
                                                }),
                                                unitsData: mediumUnitsData,
                                                featuredChecked: featuredChecked,
                                                onCheckBoxClick: onCheckBoxClick,
                                                unitsSubHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "sectionName.medium.info"
                                                })
                                            }),
                                            largeUnitsData && (largeChecked || featuredChecked || indoorcarChecked || nothingChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_section, {
                                                checkName: "Large",
                                                unitsHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "sectionName.large"
                                                }),
                                                unitsData: largeUnitsData,
                                                featuredChecked: featuredChecked,
                                                onCheckBoxClick: onCheckBoxClick,
                                                unitsSubHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "sectionName.large.info"
                                                })
                                            }),
                                            xLargeUnitsData && (xlargeChecked || featuredChecked || indoorcarChecked || nothingChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_section, {
                                                checkName: "xLarge",
                                                unitsHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "sectionName.xlarge"
                                                }),
                                                unitsData: xLargeUnitsData,
                                                featuredChecked: featuredChecked,
                                                onCheckBoxClick: onCheckBoxClick,
                                                unitsSubHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "sectionName.xlarge.info"
                                                })
                                            }),
                                            parkingUnitsData && (parkingChecked || nothingChecked || featuredChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(outdoor_units, {
                                                parkingUnitsData: parkingUnitsData
                                            }),
                                            officeUnitsData && (officeChecked || nothingChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_section, {
                                                checkName: "office",
                                                unitsHeading: "Office Space",
                                                unitsData: officeUnitsData,
                                                featuredChecked: featuredChecked,
                                                onCheckBoxClick: onCheckBoxClick
                                            }),
                                            mailboxUnitsData && nothingChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_section, {
                                                checkName: "mailbox",
                                                unitsHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "sectionName.mailbox"
                                                }),
                                                unitsData: mailboxUnitsData,
                                                featuredChecked: featuredChecked,
                                                onCheckBoxClick: onCheckBoxClick
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(requestcallback_modal/* default */.Z, {
                                                facilityId: facilityId,
                                                unitRate: unitInfo.unitRate,
                                                unitDimensions: unitInfo.dimensions,
                                                ero: true,
                                                unitTypeId: unitInfo.unitTypeId,
                                                PromotionSLName: unitInfo.PromotionSLName,
                                                promotionDescription: unitInfo.promotionDescription,
                                                consessionId: unitInfo.consessionId,
                                                unitWidth: unitInfo.unitWidth,
                                                unitLength: unitInfo.unitLength,
                                                formType: unitInfo.formType
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(no_units_facility, {
                                        onCheckBoxClick: onCheckBoxClick
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnitFilterPop, {
                        onCheckBoxClick: onCheckBoxClick,
                        featuredChecked: featuredChecked,
                        smallChecked: smallChecked,
                        mediumChecked: mediumChecked,
                        largeChecked: largeChecked,
                        heatedChecked: heatedChecked,
                        climateControlledChecked: climateControlledChecked,
                        driveupChecked: driveupChecked,
                        parkingChecked: parkingChecked,
                        indoorcarChecked: indoorcarChecked,
                        xlargeChecked: xlargeChecked,
                        officeChecked: officeChecked,
                        uniqueUnitTypes: uniqueUnitTypes,
                        parkingBlur: parkingBlur,
                        indoorcarBlur: indoorcarBlur
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var units_filter = (UnitsFilter);

// EXTERNAL MODULE: ./src/components/store-locator/unit-filter-popup.tsx + 1 modules
var unit_filter_popup = __webpack_require__(59925);
;// CONCATENATED MODULE: ./src/components/store-locator/units-hours-tab.tsx
















var ClientReviews = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59100));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59100)
            ];
        }
    }
});
var MobileUnitSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7547).then(__webpack_require__.bind(__webpack_require__, 57547));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57547)
            ];
        }
    }
});
var units_hours_tab_ShopSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4452).then(__webpack_require__.bind(__webpack_require__, 74452));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74452)
            ];
        }
    }
});
var UnitsHoursTab = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), featuredChecked = ref3[0], setfeaturedChecked = ref3[1];
    var ref4 = (0,react.useState)(false), smallChecked = ref4[0], setsmallChecked = ref4[1];
    var ref5 = (0,react.useState)(false), mediumChecked = ref5[0], setmediumChecked = ref5[1];
    var ref6 = (0,react.useState)(false), largeChecked = ref6[0], setlargeChecked = ref6[1];
    var ref7 = (0,react.useState)(false), heatedChecked = ref7[0], setHeatedChecked = ref7[1];
    var ref8 = (0,react.useState)(false), climateControlledChecked = ref8[0], setClimateControlledChecked = ref8[1];
    var ref9 = (0,react.useState)(false), driveupChecked = ref9[0], setDriveUpChecked = ref9[1];
    var ref10 = (0,react.useState)(false), parkingChecked = ref10[0], setParkingChecked = ref10[1];
    var ref11 = (0,react.useState)(false), indoorcarChecked = ref11[0], setindoorcarChecked = ref11[1];
    var ref12 = (0,react.useState)(false), xlargeChecked = ref12[0], setXlargeChecked = ref12[1];
    var ref13 = (0,react.useState)(false), officeChecked = ref13[0], setOfficeChecked = ref13[1];
    var ref14 = (0,react.useState)([]), smallUnitsData = ref14[0], setsmallUnitsData = ref14[1];
    var ref15 = (0,react.useState)([]), largeUnitsData = ref15[0], setlargeUnitsData = ref15[1];
    var ref16 = (0,react.useState)([]), mediumUnitsData = ref16[0], setmediumUnitsData = ref16[1];
    var ref17 = (0,react.useState)([]), xLargeUnitsData = ref17[0], setxLargeUnitsData = ref17[1];
    var ref18 = (0,react.useState)([]), parkingUnitsData = ref18[0], setparkingUnitsData = ref18[1];
    var ref19 = (0,react.useState)([]), officeUnitsData = ref19[0], setofficeUnitsData = ref19[1];
    var ref20 = (0,react.useState)([]), featurefilterData = ref20[0], setfeaturefilterData = ref20[1];
    var ref21 = (0,react.useState)([]), filteredData = ref21[0], setFilteredData = ref21[1];
    var ref22 = (0,react.useState)([]), finalData = ref22[0], setFinalData = ref22[1];
    var ref23 = (0,react.useState)(false), indoorcarBlur = ref23[0], setindoorcarBlur = ref23[1];
    var ref24 = (0,react.useState)(false), nothingChecked = ref24[0], setNothingChecked = ref24[1];
    var ref25 = (0,react.useState)(false), filterDot = ref25[0], setFilterDot = ref25[1];
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var unitInfo = headerFooterData.viewUnitInfo;
    var facilityID = unitInfo.facilityID ? unitInfo.facilityID : constants/* DEFAULT_FACILITY_ID */.MS;
    var cords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var ref26 = (0,react.useState)(false), flag = ref26[0], setFlag = ref26[1];
    var ratingData = props.ratingData, facilityData = props.facilityData, brandRelatedData = props.brandRelatedData, uniqueUnitTypes = props.uniqueUnitTypes, UnitsData = props.UnitsData;
    var parkingBlur = !(0,filterlogicInfo/* isParking */.iI)(UnitsData);
    var aboutTitle = facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : ref.About_Title;
    var onCheckBoxClick = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        if (value === "Featured") {
            setfeaturedChecked(!featuredChecked);
            setsmallChecked(false);
            setlargeChecked(false);
            setmediumChecked(false);
            setXlargeChecked(false);
            setParkingChecked(false);
            setindoorcarChecked(false);
            setOfficeChecked(false);
            setDriveUpChecked(false);
            setHeatedChecked(false);
            setClimateControlledChecked(false);
        }
        if (value === "Small") {
            setsmallChecked(!smallChecked);
            setfeaturedChecked(false);
        }
        if (value === "Medium") {
            setmediumChecked(!mediumChecked);
            setfeaturedChecked(false);
        }
        if (value === "Large") {
            setlargeChecked(!largeChecked);
            setfeaturedChecked(false);
        }
        if (value === "heated") {
            setHeatedChecked(!heatedChecked);
            setClimateControlledChecked(false);
        }
        if (value === "driveUp") {
            setDriveUpChecked(!driveupChecked);
        }
        if (value === "xLarge") {
            setfeaturedChecked(false);
            setXlargeChecked(!xlargeChecked);
        }
        if (value === "parking") {
            setfeaturedChecked(false);
            setParkingChecked(!parkingChecked);
        }
        if (value === "indoorcar") {
            setfeaturedChecked(false);
            setsmallChecked(false);
            setlargeChecked(false);
            setmediumChecked(false);
            setXlargeChecked(false);
            setHeatedChecked(false);
            setClimateControlledChecked(false);
            setOfficeChecked(false);
            setDriveUpChecked(false);
            setfeaturedChecked(false);
            setindoorcarChecked(!indoorcarChecked);
        }
        if (value === "office") {
            setfeaturedChecked(false);
            setOfficeChecked(!officeChecked);
        }
        if (value === "clear") {
            setfeaturedChecked(false);
            setsmallChecked(false);
            setlargeChecked(false);
            setmediumChecked(false);
            setXlargeChecked(false);
            setParkingChecked(false);
            setindoorcarChecked(false);
            setOfficeChecked(false);
            setDriveUpChecked(false);
            setHeatedChecked(false);
            setClimateControlledChecked(false);
            setFilteredData(UnitsData);
        }
        if (value === "climateControlled") {
            setClimateControlledChecked(!climateControlledChecked);
            setHeatedChecked(false);
        }
        if (value === "Featured" && checked === true) {
            setfeaturefilterData((0,filterlogicInfo/* featuredData */.u5)(UnitsData));
            setFilteredData([]);
        } else if (featuredChecked === false) {
            setfeaturefilterData([]);
        }
        if (value === "Small" || value === "Medium" || value === "Large" || value === "xLarge" || value === "parking" || value === "office") {
            if (checked) {
                if (indoorcarChecked && value !== "parking") {
                    // remove indoor car storage filter and add the selected filter
                    var updatedUnits = (0,filterlogicInfo/* removeIndoorParkingUnitsData */.uB)(filteredData);
                    setindoorcarChecked(false);
                    setFilteredData((0,_to_consumable_array/* default */.Z)(updatedUnits).concat((0,_to_consumable_array/* default */.Z)((0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(UnitsData, value))));
                } else if (indoorcarChecked && parkingChecked) {
                    // remove all filters except parking and add the selected filter
                    setindoorcarChecked(false);
                    setDriveUpChecked(false);
                    setHeatedChecked(false);
                    var parking = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(UnitsData, "parking");
                    setFilteredData((0,_to_consumable_array/* default */.Z)(parking).concat((0,_to_consumable_array/* default */.Z)((0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(UnitsData, value))));
                } else {
                    // add selected filter
                    setFilteredData((0,_to_consumable_array/* default */.Z)(filteredData).concat((0,_to_consumable_array/* default */.Z)((0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(UnitsData, value))));
                }
            } else {
                setFilteredData((0,filterlogicInfo/* removeUnitsDataWithSize */.Sy)(filteredData, value));
            }
        }
        if (value === "indoorcar") {
            if (checked) {
                // reset filteredData
                var indoor = (0,filterlogicInfo/* isIndoorParking */.Mt)(UnitsData);
                if (parkingChecked) {
                    setFilteredData((0,_to_consumable_array/* default */.Z)(indoor).concat((0,_to_consumable_array/* default */.Z)((0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(UnitsData, "parking"))));
                } else {
                    setFilteredData(indoor);
                }
            } else {
                setFilteredData((0,filterlogicInfo/* removeIndoorParkingUnitsData */.uB)(filteredData));
            }
        }
    };
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var obj = {
            lat: parseFloat(props === null || props === void 0 ? void 0 : (ref = props.facilityData) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Address) === null || ref2 === void 0 ? void 0 : ref2.Latitude),
            lng: parseFloat(props === null || props === void 0 ? void 0 : (ref3 = props.facilityData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Address) === null || ref5 === void 0 ? void 0 : ref5.Longitude)
        };
        cords.setLatLog(obj);
        setFlag(true);
    }, []);
    (0,react.useEffect)(function() {
        setsmallChecked(false);
        setmediumChecked(false);
        setlargeChecked(false);
        setHeatedChecked(false);
        setDriveUpChecked(false);
        setParkingChecked(false);
        setindoorcarChecked(false);
        setindoorcarChecked(false);
        setXlargeChecked(false);
        setOfficeChecked(false);
    }, [
        props
    ]);
    (0,react.useEffect)(function() {
        setfeaturedChecked(true);
        setfeaturefilterData((0,filterlogicInfo/* featuredData */.u5)(UnitsData));
        setFinalData((0,filterlogicInfo/* featuredData */.u5)(UnitsData));
        setindoorcarBlur(!(0,filterlogicInfo/* hasIndoorParkingUnits */.RE)(UnitsData));
    }, [
        UnitsData
    ]);
    (0,react.useEffect)(function() {
        var smallUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "Small");
        var largeUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "Large");
        var mediumUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "Medium");
        var officeUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "office");
        var xLargeUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "xLarge");
        var outdoorUnits = (0,filterlogicInfo/* filterUnitsDataWithSize */.MZ)(finalData, "parking");
        setsmallUnitsData(smallUnits);
        setlargeUnitsData(largeUnits);
        setmediumUnitsData(mediumUnits);
        setxLargeUnitsData(xLargeUnits);
        setparkingUnitsData(outdoorUnits);
        setofficeUnitsData(officeUnits);
    }, [
        finalData
    ]);
    (0,react.useEffect)(function() {
        if (smallChecked || mediumChecked || largeChecked || parkingChecked || indoorcarChecked || xlargeChecked || officeChecked || featuredChecked || heatedChecked || driveupChecked || climateControlledChecked) {
            setFilterDot(true);
        } else {
            setFilterDot(false);
        }
        if (!smallChecked && !mediumChecked && !largeChecked && !parkingChecked && !indoorcarChecked && !xlargeChecked && !officeChecked && !featuredChecked) {
            setNothingChecked(true);
            setFinalData((0,filterlogicInfo/* filterUnitsDataByfeatures */.IF)(UnitsData, heatedChecked, driveupChecked, climateControlledChecked));
        } else if (featuredChecked) {
            setNothingChecked(false);
            setFinalData((0,filterlogicInfo/* filterUnitsDataByfeatures */.IF)(featurefilterData, heatedChecked, driveupChecked, climateControlledChecked));
        } else if (smallChecked || mediumChecked || largeChecked || parkingChecked || indoorcarChecked || xlargeChecked || officeChecked) {
            setNothingChecked(false);
            setFinalData((0,filterlogicInfo/* filterUnitsDataByfeatures */.IF)(filteredData, heatedChecked, driveupChecked, climateControlledChecked));
        }
        if (heatedChecked || driveupChecked || climateControlledChecked) {
            setfeaturedChecked(false);
        }
    }, [
        smallChecked,
        mediumChecked,
        largeChecked,
        parkingChecked,
        xlargeChecked,
        officeChecked,
        featuredChecked,
        heatedChecked,
        driveupChecked,
        indoorcarChecked,
        climateControlledChecked, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                id: "sv-units-hours-tabs",
                className: "sv-units-hours-tabs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row g-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        id: "jump-to-units",
                                        ref: props.jumpToUnitsRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "sv-units-tab-btn-containers",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_filter_popup["default"], {
                                                            onCheckBoxClick: onCheckBoxClick,
                                                            featuredChecked: featuredChecked,
                                                            smallChecked: smallChecked,
                                                            mediumChecked: mediumChecked,
                                                            largeChecked: largeChecked,
                                                            heatedChecked: heatedChecked,
                                                            climateControlledChecked: climateControlledChecked,
                                                            driveupChecked: driveupChecked,
                                                            parkingChecked: parkingChecked,
                                                            indoorcarChecked: indoorcarChecked,
                                                            xlargeChecked: xlargeChecked,
                                                            officeChecked: officeChecked,
                                                            uniqueUnitTypes: uniqueUnitTypes,
                                                            parkingBlur: parkingBlur,
                                                            indoorcarBlur: indoorcarBlur
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "d-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "sv-units-tab-btn flex-fill me-2",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_filter, {
                                                                        hasFilter: !filterDot
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "sv-units-tab-btn flex-fill",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(size_help/* default */.Z, {})
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "container",
                                                children: [
                                                    finalData && (finalData === null || finalData === void 0 ? void 0 : finalData.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            smallUnitsData && (smallChecked || featuredChecked || nothingChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileUnitSection, {
                                                                unitsHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.small"
                                                                }),
                                                                checkName: "Small",
                                                                unitsData: smallUnitsData,
                                                                featuredChecked: featuredChecked,
                                                                onCheckBoxClick: onCheckBoxClick,
                                                                heatedChecked: heatedChecked,
                                                                climateControlledChecked: climateControlledChecked,
                                                                driveupChecked: driveupChecked,
                                                                unitsSubHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.small.info"
                                                                })
                                                            }),
                                                            mediumUnitsData && (mediumChecked || featuredChecked || indoorcarChecked || nothingChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileUnitSection, {
                                                                checkName: "Medium",
                                                                unitsHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.medium"
                                                                }),
                                                                unitsData: mediumUnitsData,
                                                                featuredChecked: featuredChecked,
                                                                onCheckBoxClick: onCheckBoxClick,
                                                                unitsSubHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.medium.info"
                                                                })
                                                            }),
                                                            largeUnitsData && (largeChecked || indoorcarChecked || featuredChecked || nothingChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileUnitSection, {
                                                                checkName: "Large",
                                                                unitsHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.large"
                                                                }),
                                                                unitsData: largeUnitsData,
                                                                featuredChecked: featuredChecked,
                                                                onCheckBoxClick: onCheckBoxClick,
                                                                unitsSubHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.large.info"
                                                                })
                                                            }),
                                                            xLargeUnitsData && (xlargeChecked || indoorcarChecked || nothingChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileUnitSection, {
                                                                checkName: "xLarge",
                                                                unitsHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.xlarge"
                                                                }),
                                                                unitsData: xLargeUnitsData,
                                                                featuredChecked: featuredChecked,
                                                                onCheckBoxClick: onCheckBoxClick,
                                                                unitsSubHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.xlarge.info"
                                                                })
                                                            }),
                                                            parkingUnitsData && (parkingChecked || nothingChecked || featuredChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileUnitSection, {
                                                                checkName: "parking",
                                                                unitsHeading: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.outdoorParking"
                                                                }),
                                                                unitsData: parkingUnitsData,
                                                                featuredChecked: featuredChecked,
                                                                onCheckBoxClick: onCheckBoxClick
                                                            }),
                                                            officeUnitsData && (officeChecked || nothingChecked) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileUnitSection, {
                                                                checkName: "office",
                                                                unitsHeading: "Office Space",
                                                                unitsData: officeUnitsData,
                                                                featuredChecked: featuredChecked,
                                                                onCheckBoxClick: onCheckBoxClick
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "card-content sv-shop-store-para",
                                                                dangerouslySetInnerHTML: {
                                                                    __html: browser_default().sanitize(brandRelatedData === null || brandRelatedData === void 0 ? void 0 : (ref1 = brandRelatedData.Shop_Store) === null || ref1 === void 0 ? void 0 : ref1.Description)
                                                                }
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(no_units_facility, {
                                                        onCheckBoxClick: onCheckBoxClick
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(units_hours_tab_ShopSection, {
                                                        shopStore: brandRelatedData === null || brandRelatedData === void 0 ? void 0 : brandRelatedData.Shop_Store
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    flag && /*#__PURE__*/ (0,jsx_runtime.jsx)(store_locator/* default */.Z, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            className: "sv-hours-content",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "container p-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "para text-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "store-desc"
                                                        }),
                                                        "."
                                                    ]
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                        className: "reviews",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientReviews, {
                                            ratingData: ratingData
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                        className: "sv-about-access-storage",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "container",
                                            children: [
                                                aboutTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "section-heading",
                                                    children: aboutTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: browser_default().sanitize(facilityData === null || facilityData === void 0 ? void 0 : (ref2 = facilityData.attributes) === null || ref2 === void 0 ? void 0 : ref2.About_Facility)
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(requestcallback_modal/* default */.Z, {
                facilityId: facilityID,
                unitRate: unitInfo.unitRate,
                unitDimensions: unitInfo.dimensions,
                ero: true,
                unitTypeId: unitInfo.unitTypeId,
                PromotionSLName: unitInfo.PromotionSLName,
                promotionDescription: unitInfo.promotionDescription,
                consessionId: unitInfo.consessionId,
                unitWidth: unitInfo.unitWidth,
                unitLength: unitInfo.unitLength,
                formType: unitInfo.formType
            })
        ]
    });
};
/* harmony default export */ var units_hours_tab = (UnitsHoursTab);

;// CONCATENATED MODULE: ./src/components/store-locator/location-landing.tsx






















var LocationLanding = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(window.innerWidth >= 768), isDesktop = ref3[0], setDesktop = ref3[1];
    var ref4 = (0,react.useState)(false), showJumpButton = ref4[0], setShowJumpButton = ref4[1];
    var ref5 = (0,react.useState)(true), isAbove = ref5[0], setIsAbove = ref5[1];
    var jumpToUnitsRef = (0,react.useRef)(null);
    var facilityData = props.facilityData, articlesData = props.articlesData, brandRelatedData = props.brandRelatedData, reviewsData = props.reviewsData, unitData = props.unitData, promotions = props.promotions;
    var lcode = facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : ref.Facility_ID;
    var ref6 = (0,react.useState)(), ratingData = ref6[0], setRating = ref6[1];
    var blogData = articlesData === null || articlesData === void 0 ? void 0 : (ref1 = articlesData.Blog) === null || ref1 === void 0 ? void 0 : ref1.data;
    var ref7 = (0,react.useState)(false), flag = ref7[0], setFlag = ref7[1];
    var facilityLcode = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    facilityLcode.setFacilityLCode(lcode);
    var locale = (0,next_router.useRouter)().locale;
    var ref8 = (0,react.useState)([]), uniqueUnitTypes = ref8[0], setUnitsTypes = ref8[1];
    var cords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var updateMedia = function() {
        setDesktop(window.innerWidth >= 768);
    };
    var scrollToUnits = function() {
        var reviews = document.getElementById("sv-units-hours-tabs");
        if (!reviews) return;
        window.scrollTo({
            top: reviews.offsetTop - 80,
            behavior: "smooth"
        });
    };
    var setIntercom = function(hide) {
        var launcher = document.querySelector(".intercom-launcher");
        if (hide === true) {
            if (launcher) {
                launcher.style.left = "20px";
                launcher.style.right = "auto";
                launcher.style.bottom = "80px";
            }
        } else if (launcher) {
            launcher.style.left = "20px";
            launcher.style.right = "auto";
            launcher.style.bottom = "20px";
        }
    };
    // useEffect(() => {
    //   setIntercom(true);
    //   const interval = setInterval(() => {
    //     setIntercom(showJumpButton);
    //   }, 1000);
    //   return () => {
    //     clearInterval(interval);
    //     setIntercom(false); // Set hide to false when the component unmounts
    //   };
    // }, []);
    (0,react.useEffect)(function() {
        setIntercom(true);
        var interval = setInterval(function() {
            setIntercom(showJumpButton);
        }, 1000);
        return function() {
            clearInterval(interval);
            setIntercom(false); // Set hide to false when the component unmounts
        };
    }, [
        showJumpButton
    ]);
    var firstPromotionTitle = promotions.length > 0 ? promotions[0]["Banner_".concat(locale === "fr" ? "FR" : "EN", "_Title")] : "50% Off 12 weeks"; // Default text if no promotions exist
    var firstPromotionBadge = promotions.length > 0 ? promotions[0]["Banner_".concat(locale === "fr" ? "FR" : "EN", "_Badge")] : "Flash Sale"; // Default text if no promotions exist
    var firstPromotionLink = promotions.length > 0 ? promotions[0]["Banner_".concat(locale === "fr" ? "FR" : "EN", "_Link")] : "#"; // Default text if no promotions exist
    (0,react.useEffect)(function() {
        window.addEventListener("resize", updateMedia);
        return function() {
            return window.removeEventListener("resize", updateMedia);
        };
    });
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        var obj;
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            setShowJumpButton(!entry.isIntersecting);
            setIsAbove(entry.boundingClientRect.top > 0);
            setIntercom(!entry.isIntersecting);
        }, {
            threshold: 0.1
        });
        if (jumpToUnitsRef.current) {
            observer.observe(jumpToUnitsRef.current);
        }
        if ((facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.Address) === null || ref1 === void 0 ? void 0 : ref1.Latitude) === null && (facilityData === null || facilityData === void 0 ? void 0 : (ref2 = facilityData.attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Address) === null || ref3 === void 0 ? void 0 : ref3.Longitude) === null) {
            var ref4, ref5;
            var location = facilityData === null || facilityData === void 0 ? void 0 : (ref4 = facilityData.attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Address) === null || ref5 === void 0 ? void 0 : ref5.Location.split("(")[1].slice(0, -1);
            var newLocation = location.split(" ");
            obj = {
                lat: parseFloat(newLocation[1]),
                lng: parseFloat(newLocation[0])
            };
        } else {
            var ref6, ref7, ref8, ref9;
            obj = {
                lat: parseFloat(facilityData === null || facilityData === void 0 ? void 0 : (ref6 = facilityData.attributes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Address) === null || ref7 === void 0 ? void 0 : ref7.Latitude),
                lng: parseFloat(facilityData === null || facilityData === void 0 ? void 0 : (ref8 = facilityData.attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Address) === null || ref9 === void 0 ? void 0 : ref9.Longitude)
            };
        }
        cords.setLatLog(obj);
        cords.setLatLangs(obj);
        cords.setLatLogCity({});
        setFlag(true);
        return function() {
            if (jumpToUnitsRef.current) {
                observer.unobserve(jumpToUnitsRef.current);
            }
        };
    }, []);
    var values = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    (0,react.useEffect)(function() {
        var uniqueTypes = unitData.map(function(item) {
            return item.category;
        }).filter(function(value, index, self) {
            return self.indexOf(value) === index;
        });
        if (unitData.find(function(item) {
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.hasAmenities) === null || ref === void 0 ? void 0 : ref.climateControlled) === true;
        })) {
            uniqueTypes.push("climateControlled");
        }
        setUnitsTypes(uniqueTypes);
        setRating(reviewsData);
        values === null || values === void 0 ? void 0 : values.setShowFooter(true);
        values === null || values === void 0 ? void 0 : values.setShowHeaderFooter(true);
    }, [
        lcode,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "sv-page-content view-units-wrapper",
        children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tab-view d-none d-lg-block d-md-block",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb, {
                            facilityData: facilityData
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_gallery, {
                            facilityData: facilityData
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row gx-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-lg-6 col-md-12 col-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(title_desc, {
                                            facilityData: facilityData,
                                            ratingData: ratingData
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(top_features, {
                                            facilityData: facilityData
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-lg-6 col-md-12 col-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row gy-3 gx-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-lg-6 col-md-6 col-sm-12 col-12 sv-access-hours",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(hours, {
                                                            facilityData: facilityData
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(address, {
                                                            facilityData: facilityData,
                                                            isDesktop: isDesktop
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-lg-6 col-md-6 col-sm-12 col-12",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(map_view, {
                                                        facilityData: facilityData
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(store_promotions, {
                                                promotions: promotions
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(units_filter, {
                    uniqueUnitTypes: uniqueUnitTypes,
                    brandRelatedData: brandRelatedData,
                    lcode: lcode,
                    UnitsData: unitData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(client_review["default"], {
                    ratingData: ratingData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "more-locations-near-me",
                    children: flag && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            (values === null || values === void 0 ? void 0 : values.isShowSelfHeader) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "section-heading",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "find-near-facility"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(store_locator/* default */.Z, {
                                cityTitle: "facilities"
                            })
                        ]
                    })
                }),
                blogData != null && ((ref2 = Object.keys(blogData)) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(community_involvement, {
                    blogData: blogData === null || blogData === void 0 ? void 0 : blogData.attributes
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(about_page, {
                    brandRelatedData: brandRelatedData,
                    facilityData: facilityData
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "sv-view-units-mobile sv-landing-mobile-view d-lg-none d-md-none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_banner, {
                    facilityData: facilityData,
                    brandRelatedData: brandRelatedData,
                    ratingData: ratingData,
                    promotions: promotions
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(units_hours_tab, {
                    jumpToUnitsRef: jumpToUnitsRef,
                    uniqueUnitTypes: uniqueUnitTypes,
                    brandRelatedData: brandRelatedData,
                    blogData: blogData,
                    facilityData: facilityData,
                    UnitsData: unitData,
                    ratingData: ratingData
                }),
                showJumpButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sv-units-fixed-footer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex align-items-center justify-content-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: firstPromotionLink,
                                        className: "badge sv-deal-pill text-decoration-none mb-2",
                                        id: "dealPill",
                                        children: firstPromotionBadge
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        className: "sv-hour-day mb-0 mt-2",
                                        children: firstPromotionTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "btn sv-play-video-btn",
                                type: "button",
                                onClick: function() {
                                    return scrollToUnits();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "jumpToUnits"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/jump-to-units-icon.svg",
                                            alt: "",
                                            style: {
                                                transform: isAbove ? "rotate(0deg)" : "rotate(180deg)"
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var location_landing = (LocationLanding);


/***/ }),

/***/ 59925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ unit_filter_popup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./public/images/icons/x.svg
/* harmony default export */ var x = ({"src":"/_next/static/media/x.519429a8.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./src/components/store-locator/unit-filter-popup.tsx



var UnitFilterPop = function(props) {
    var onCheckBoxClick = props.onCheckBoxClick, featuredChecked = props.featuredChecked, smallChecked = props.smallChecked, mediumChecked = props.mediumChecked, largeChecked = props.largeChecked, heatedChecked = props.heatedChecked, climateControlledChecked = props.climateControlledChecked, driveupChecked = props.driveupChecked, parkingChecked = props.parkingChecked, xlargeChecked = props.xlargeChecked, officeChecked = props.officeChecked, uniqueUnitTypes = props.uniqueUnitTypes, smallBlur = props.smallBlur, mediumBlur = props.mediumBlur, largeBlur = props.largeBlur, xlargeBlur = props.xlargeBlur, officeBlur = props.officeBlur, parkingBlur = props.parkingBlur, heatedBlur = props.heatedBlur, climateControlledBlur = props.climateControlledBlur, driveupBlur = props.driveupBlur, indoorcarChecked = props.indoorcarChecked, indoorcarBlur = props.indoorcarBlur, locale = props.locale;
    var labelClass = function(isChecked, isBlur) {
        return "".concat(isChecked ? "sv-checkbox-checked-label form-check-label " : "form-check-label ").concat(isBlur ? "form-check-label-disabled" : "");
    };
    var secondaryLabelClass = function(isChecked, isBlur) {
        return "".concat(isChecked ? "form-check-secondary-label form-check-secondary-label-visible " : "form-check-secondary-label ", "\n    ").concat(isBlur ? "form-check-secondary-label-disabled" : "");
    };
    var handleCloseClick = function(e) {
        e.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal fade",
            id: "SvFilterModalUnit",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-dialog modal-dialog-centered bg-transparent",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-content rounded-3 bg-transparent",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sv-filter-container bg-transparent",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "closebtn",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: x.src,
                                    alt: "close",
                                    className: "sv-close-btn",
                                    "data-bs-dismiss": "modal"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sv-size-help-guide border-0 shadow-none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "sv-filter-type-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                className: "filter-section-title",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "filters.selfStorage"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-check",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-check-input",
                                                        type: "checkbox",
                                                        value: "Featured",
                                                        checked: featuredChecked,
                                                        onChange: function(e) {
                                                            return onCheckBoxClick(e);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "label-container",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "",
                                                                className: featuredChecked ? "sv-checkbox-checked-label form-check-label " : "form-check-label",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.featuedUnits"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: featuredChecked ? "form-check-secondary-label form-check-secondary-label-visible" : "form-check-secondary-label",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "filters.mostPopular"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            uniqueUnitTypes.includes("Small") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-check",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-check-input",
                                                        type: "checkbox",
                                                        value: "Small",
                                                        checked: smallChecked,
                                                        onChange: function(e) {
                                                            return onCheckBoxClick(e);
                                                        },
                                                        disabled: smallBlur
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "label-container",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "flexCheckDefault",
                                                                className: labelClass(smallChecked, smallBlur),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.small"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: secondaryLabelClass(smallChecked, smallBlur),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "filters.seasonalItems"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            uniqueUnitTypes.includes("Medium") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-check",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-check-input",
                                                        type: "checkbox",
                                                        value: "Medium",
                                                        checked: mediumChecked,
                                                        onChange: function(e) {
                                                            return onCheckBoxClick(e);
                                                        },
                                                        disabled: mediumBlur
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "label-container",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "flexCheckDefault",
                                                                className: labelClass(mediumChecked, mediumBlur),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.medium"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: secondaryLabelClass(mediumChecked, mediumBlur),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "filters.studioApartment"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            uniqueUnitTypes.includes("Large") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-check",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-check-input",
                                                        type: "checkbox",
                                                        value: "Large",
                                                        checked: largeChecked,
                                                        onChange: function(e) {
                                                            return onCheckBoxClick(e);
                                                        },
                                                        disabled: largeBlur
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "label-container",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "flexCheckDefault",
                                                                className: labelClass(largeChecked, largeBlur),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.large"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: secondaryLabelClass(largeChecked, largeBlur),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "filters.2-4Bedroom"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (!indoorcarBlur || !parkingBlur) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "sv-filter-type-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                className: "filter-section-title",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "vehicle-storage"
                                                })
                                            }),
                                            !parkingBlur && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "form-check",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            className: "form-check-input",
                                                            type: "checkbox",
                                                            value: "parking",
                                                            checked: parkingChecked,
                                                            onChange: function(e) {
                                                                return onCheckBoxClick(e);
                                                            },
                                                            disabled: parkingBlur
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "label-container",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "flexCheckDefault",
                                                                    className: labelClass(parkingChecked, parkingBlur),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "sectionName.outdoorParking"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: secondaryLabelClass(parkingChecked, parkingBlur),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "filters.rvAndOversized"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            !indoorcarBlur && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-check",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-check-input",
                                                        type: "checkbox",
                                                        value: "indoorcar",
                                                        checked: indoorcarChecked,
                                                        onChange: function(e) {
                                                            return onCheckBoxClick(e);
                                                        },
                                                        disabled: indoorcarBlur
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "label-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            htmlFor: "flexCheckDefault",
                                                            className: labelClass(indoorcarChecked, indoorcarBlur),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.indoorCarStorage"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: secondaryLabelClass(indoorcarChecked, indoorcarBlur),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "filters.carsAndMotor"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (uniqueUnitTypes.includes("office") || uniqueUnitTypes.includes("xLarge")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "sv-filter-type-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                className: "filter-section-title",
                                                children: "Commercial"
                                            }),
                                            uniqueUnitTypes.includes("office") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-check",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-check-input",
                                                        type: "checkbox",
                                                        value: "office",
                                                        checked: officeChecked,
                                                        onChange: function(e) {
                                                            return onCheckBoxClick(e);
                                                        },
                                                        disabled: officeBlur
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "label-container",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "flexCheckDefault",
                                                                className: labelClass(officeChecked, officeBlur),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "office-space"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: secondaryLabelClass(officeChecked, officeBlur),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "filters.officeEquipment"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            uniqueUnitTypes.includes("xLarge") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-check",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-check-input",
                                                        type: "checkbox",
                                                        value: "xLarge",
                                                        checked: xlargeChecked,
                                                        onChange: function(e) {
                                                            return onCheckBoxClick(e);
                                                        },
                                                        disabled: xlargeBlur
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "label-container",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "flexCheckDefault",
                                                                className: labelClass(xlargeChecked, xlargeBlur),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "sectionName.xlarge"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: secondaryLabelClass(xlargeChecked, xlargeBlur),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "filters.toolsAndEquipment"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sv-size-help-guide",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sv-filter-type-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            className: "filter-section-title",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "filters.UnitFeatures"
                                            })
                                        }),
                                        uniqueUnitTypes.includes("climateControlled") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "form-check",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "form-check-input",
                                                    type: "checkbox",
                                                    value: "climateControlled",
                                                    checked: climateControlledChecked,
                                                    onChange: function(e) {
                                                        return onCheckBoxClick(e);
                                                    },
                                                    disabled: climateControlledBlur
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "label-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "flexCheckDefault",
                                                            className: labelClass(climateControlledChecked, climateControlledBlur),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "filters.climateControlled"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: secondaryLabelClass(climateControlledChecked, climateControlledBlur),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "filters.protectFromHotAndCold"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "form-check",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "form-check-input",
                                                    type: "checkbox",
                                                    value: "heated",
                                                    checked: heatedChecked,
                                                    onChange: function(e) {
                                                        return onCheckBoxClick(e);
                                                    },
                                                    disabled: heatedBlur
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "label-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "flexCheckDefault",
                                                            className: labelClass(heatedChecked, heatedBlur),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "filters.heated"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: secondaryLabelClass(heatedChecked, heatedBlur),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "filters.protectFromWinter"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "form-check",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "form-check-input",
                                                    type: "checkbox",
                                                    value: "driveUp",
                                                    checked: driveupChecked,
                                                    onChange: function(e) {
                                                        return onCheckBoxClick(e);
                                                    },
                                                    disabled: driveupBlur
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "label-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "flexCheckDefault",
                                                            className: labelClass(driveupChecked, driveupBlur),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "filters.driveup"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: secondaryLabelClass(driveupChecked, driveupBlur),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "filters.accessFromOutside"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sv-filter-buttons-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: locale === "en" ? "btn sv-filter-btn text-capitalize" : "btn sv-filter-btn text-normal",
                                        type: "button",
                                        onClick: function() {
                                            return onCheckBoxClick({
                                                target: {
                                                    value: "clear",
                                                    checked: true
                                                }
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "filters.clearAll"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: locale === "en" ? "btn sv-search-btn text-uppercase" : "btn sv-search-btn",
                                        type: "button",
                                        "data-bs-dismiss": "modal",
                                        onClick: handleCloseClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "buttons.search"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var unit_filter_popup = (UnitFilterPop);


/***/ }),

/***/ 38131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ formatAsPrice; }
/* harmony export */ });
var formatAsPrice = function(price) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-CA", showFractional = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    // We need a country code so that CAD doesn't display on the formatted string
    var qualifiedLocal = locale === "fr" ? "fr-CA" : "en-CA";
    var formatter = new Intl.NumberFormat(qualifiedLocal, {
        style: "currency",
        currency: "CAD",
        maximumFractionDigits: showFractional ? 2 : 0,
        minimumFractionDigits: showFractional ? 2 : 0
    });
    return formatter.format(Number(price));
};


/***/ }),

/***/ 93342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ getFacilityPageDataOffice; },
/* harmony export */   "md": function() { return /* binding */ getNearestLocationData; }
/* harmony export */ });
/* unused harmony exports getAllUnitsData, getFacilityPageData, getLandingPageData, getVehiclePageDataSEO */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15122);
/* harmony import */ var _apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33891);




var getNearestLocationData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(brand, locale, lat, lng, originalat, originalng, distance) {
        var response;
        function removeEmptyUnitLocations(location, index, arr) {
            var ref;
            if (!(location === null || location === void 0 ? void 0 : location.priceInfo) || (location === null || location === void 0 ? void 0 : (ref = location.priceInfo) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                arr.splice(index, 1);
                return true;
            }
            return false;
        }
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getNearestStoreLocator */ .Bx(brand, locale, lat, lng, originalat, originalng, distance)), "get")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response === null || response === void 0 ? void 0 : response.data.filter(removeEmptyUnitLocations)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function getNearestLocationData(brand, locale, lat, lng, originalat, originalng, distance) {
        return _ref.apply(this, arguments);
    };
}();
var getLandingPageData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(location, locale) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getLandingPage */ .Tz(location, locale)), "get")
            ];
        });
    });
    return function getLandingPageData(location, locale) {
        return _ref.apply(this, arguments);
    };
}();
var getFacilityPageData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(location, brand, locale, facilityLen) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getFacilitiesInfo */ .jV(location, brand, locale, facilityLen)), "get")
            ];
        });
    });
    return function getFacilityPageData(location, brand, locale, facilityLen) {
        return _ref.apply(this, arguments);
    };
}();
var getFacilityPageDataOffice = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(facilityId, brand, locale) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getFacilitiesInfoOffice */ .vV(facilityId, brand, locale)), "get")
            ];
        });
    });
    return function getFacilityPageDataOffice(facilityId, brand, locale) {
        return _ref.apply(this, arguments);
    };
}();
var getVehiclePageDataSEO = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(location, brand, locale) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getVehicleSEOInfo */ .gC(location, brand, locale)), "get")
            ];
        });
    });
    return function getVehiclePageDataSEO(location, brand, locale) {
        return _ref.apply(this, arguments);
    };
}();
var getAllUnitsData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode, locale) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getUnitsData */ .pI(lcode, locale)), "get")
            ];
        });
    });
    return function getAllUnitsData(lcode, locale) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 63581:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sizeHelpBtnContainer":"style_sizeHelpBtnContainer__FVkp3","title":"style_title__CD5Je"};

/***/ }),

/***/ 8586:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sizeHelpBtnContainer":"style_sizeHelpBtnContainer__4nlni","title":"style_title__rAc_u","filterDot":"style_filterDot__uan_F"};

/***/ }),

/***/ 66287:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promotionDropdown":"style_promotionDropdown__lxaoK","errorText":"style_errorText__00Sh3","secondaryErrorText":"style_secondaryErrorText__yQEyB","secondaryErrorTextNone":"style_secondaryErrorTextNone__A0aWk","applyPromotion":"style_applyPromotion__8U8dG","selected":"style_selected__wrYs5","applyPromotionTextContainer":"style_applyPromotionTextContainer__cal5O","applyPromotionText":"style_applyPromotionText__tG0AP","applyPromotionTextFull":"style_applyPromotionTextFull__Z3MdU","arrow":"style_arrow__GxYoS","noPromotionText":"style_noPromotionText__pHT0j","promotionError":"style_promotionError__RJwqY","applyPromotionOpen":"style_applyPromotionOpen__S1y7_","dropdownContent":"style_dropdownContent__cnO9u","open":"style_open__ZwIv7","promotionOption":"style_promotionOption__wjTKk","promotionText":"style_promotionText__MiP25","selectedPromotion":"style_selectedPromotion__rrxxM","tag":"style_tag__ooLKO","promotionAnimation":"style_promotionAnimation__oldae","gradientTransition":"style_gradientTransition__3a5zg"};

/***/ }),

/***/ 59343:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overallratings":"home_overallratings__9p5wV"};

/***/ }),

/***/ 9271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customExpandMap":"map-view_customExpandMap__1oTxc","expandIcon":"map-view_expandIcon__nO3aD","customExitFullscreen":"map-view_customExitFullscreen__WaCei","exitCross":"map-view_exitCross__naAuI","fullscreenMode":"map-view_fullscreenMode__rsEE_"};

/***/ }),

/***/ 89978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"unitContainer":"store_unitContainer__9EZv3","imageContainer":"store_imageContainer__x0CW4","unitImage":"store_unitImage__Q24D2","unitVideoPlay":"store_unitVideoPlay__KWBlp","detailsContainer":"store_detailsContainer__XR8Kt","unitFeaturesContainer":"store_unitFeaturesContainer__VnDrZ","unitDetails":"store_unitDetails__fo79L","unitDimensions":"store_unitDimensions__7odKW","unitPrice":"store_unitPrice__Rd41Q","unitPriceText":"store_unitPriceText__tD08o","unitFeatures":"store_unitFeatures__SV1ql","unitReservationContainer":"store_unitReservationContainer__LIUp8","unitControllers":"store_unitControllers__KjICB","unitPromotionDropdown":"store_unitPromotionDropdown__DtzxL","unitReservationBtn":"store_unitReservationBtn__iG3aA","unitCallback":"store_unitCallback__hf1ap"};

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 76792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SC": function() { return /* binding */ useIsRTL; },
/* harmony export */   "vE": function() { return /* binding */ useBootstrapPrefix; }
/* harmony export */ });
/* unused harmony exports DEFAULT_BREAKPOINTS, DEFAULT_MIN_BREAKPOINT, useBootstrapBreakpoints, useBootstrapMinBreakpoint, createBootstrapComponent, ThemeConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
"use client";




const DEFAULT_BREAKPOINTS = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const DEFAULT_MIN_BREAKPOINT = 'xs';
const ThemeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  prefixes: {},
  breakpoints: DEFAULT_BREAKPOINTS,
  minBreakpoint: DEFAULT_MIN_BREAKPOINT
});
const {
  Consumer,
  Provider
} = ThemeContext;
function ThemeProvider({
  prefixes = {},
  breakpoints = DEFAULT_BREAKPOINTS,
  minBreakpoint = DEFAULT_MIN_BREAKPOINT,
  dir,
  children
}) {
  const contextValue = useMemo(() => ({
    prefixes: {
      ...prefixes
    },
    breakpoints,
    minBreakpoint,
    dir
  }), [prefixes, breakpoints, minBreakpoint, dir]);
  return /*#__PURE__*/_jsx(Provider, {
    value: contextValue,
    children: children
  });
}
function useBootstrapPrefix(prefix, defaultPrefix) {
  const {
    prefixes
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
  const {
    breakpoints
  } = useContext(ThemeContext);
  return breakpoints;
}
function useBootstrapMinBreakpoint() {
  const {
    minBreakpoint
  } = useContext(ThemeContext);
  return minBreakpoint;
}
function useIsRTL() {
  const {
    dir
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return dir === 'rtl';
}
function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  const isClassy = Component.prototype && Component.prototype.isReactComponent;
  // If it's a functional component make sure we don't break it with a ref
  const {
    prefix,
    forwardRefAs = isClassy ? 'ref' : 'innerRef'
  } = opts;
  const Wrapped = /*#__PURE__*/React.forwardRef(({
    ...props
  }, ref) => {
    props[forwardRefAs] = ref;
    const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/_jsx(Component, {
      ...props,
      bsPrefix: bsPrefix
    });
  });
  Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
  return Wrapped;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ThemeProvider)));

/***/ }),

/***/ 13773:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0});var e=__webpack_require__(85893),t=__webpack_require__(67294),o=function(){return o=Object.assign||function(e){for(var t,o=1,n=arguments.length;o<n;o++)for(var i in t=arguments[o])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},o.apply(this,arguments)};function n(e,t,o){if(o||2===arguments.length)for(var n,i=0,r=t.length;i<r;i++)!n&&i in t||(n||(n=Array.prototype.slice.call(t,0,i)),n[i]=t[i]);return e.concat(n||Array.prototype.slice.call(t))}function i(t){var n=t.size,i=void 0===n?25:n,r=t.SVGstrokeColor,l=void 0===r?"currentColor":r,a=t.SVGstorkeWidth,s=void 0===a?0:a,c=t.SVGclassName,d=void 0===c?"star-svg":c,u=t.SVGstyle;return e.jsx("svg",o({className:d,style:u,stroke:l,fill:"currentColor",strokeWidth:s,viewBox:"0 0 24 24",width:i,height:i,xmlns:"http://www.w3.org/2000/svg"},{children:e.jsx("path",{d:"M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"})}))}function r(e,t){switch(t.type){case"PointerMove":return o(o({},e),{hoverValue:t.payload,hoverIndex:t.index});case"PointerLeave":return o(o({},e),{ratingValue:e.ratingValue,hoverIndex:0,hoverValue:null});case"MouseClick":return o(o({},e),{valueIndex:e.hoverIndex,ratingValue:t.payload});default:return e}}var l="style-module_starRatingWrap__q-lJC",a="style-module_simpleStarRating__nWUxf",s="style-module_fillIcons__6---A",c="style-module_emptyIcons__Bg-FZ",d="style-module_tooltip__tKc3i";function u(){return"undefined"!=typeof window&&window.matchMedia("(pointer: coarse)").matches||"ontouchstart"in window||"undefined"!=typeof navigator&&navigator.maxTouchPoints>0}!function(e,t){void 0===t&&(t={});var o=t.insertAt;if(e&&"undefined"!=typeof document){var n=document.head||document.getElementsByTagName("head")[0],i=document.createElement("style");i.type="text/css","top"===o&&n.firstChild?n.insertBefore(i,n.firstChild):n.appendChild(i),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(document.createTextNode(e))}}(".style-module_starRatingWrap__q-lJC{display:inline-block;touch-action:none}.style-module_simpleStarRating__nWUxf{display:inline-block;overflow:hidden;position:relative;touch-action:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle;white-space:nowrap}.style-module_fillIcons__6---A{display:inline-block;overflow:hidden;position:absolute;top:0;white-space:nowrap}.style-module_emptyIcons__Bg-FZ{display:inline-block}.style-module_tooltip__tKc3i{background-color:#333;border-radius:5px;color:#fff;display:inline-block;padding:5px 15px;vertical-align:middle}"),exports.i=function(v){var p,f,h=v.onClick,y=v.onPointerMove,m=v.onPointerEnter,g=v.onPointerLeave,x=v.initialValue,_=void 0===x?0:x,C=v.iconsCount,w=void 0===C?5:C,V=v.size,k=void 0===V?40:V,S=v.readonly,b=void 0!==S&&S,M=v.rtl,G=void 0!==M&&M,I=v.customIcons,N=void 0===I?[]:I,j=v.allowFraction,P=void 0!==j&&j,A=v.style,L=v.className,R=void 0===L?"react-simple-star-rating":L,T=v.transition,W=void 0!==T&&T,z=v.allowHover,B=void 0===z||z,E=v.disableFillHover,F=void 0!==E&&E,q=v.fillIcon,O=void 0===q?null:q,H=v.fillColor,J=void 0===H?"#ffbc0b":H,K=v.fillColorArray,U=void 0===K?[]:K,Z=v.fillStyle,D=v.fillClassName,X=void 0===D?"filled-icons":D,Y=v.emptyIcon,Q=void 0===Y?null:Y,$=v.emptyColor,ee=void 0===$?"#cccccc":$,te=v.emptyStyle,oe=v.emptyClassName,ne=void 0===oe?"empty-icons":oe,ie=v.allowTitleTag,re=void 0===ie||ie,le=v.showTooltip,ae=void 0!==le&&le,se=v.tooltipDefaultText,ce=void 0===se?"Your Rate":se,de=v.tooltipArray,ue=void 0===de?[]:de,ve=v.tooltipStyle,pe=v.tooltipClassName,fe=void 0===pe?"react-simple-star-rating-tooltip":pe,he=v.SVGclassName,ye=void 0===he?"star-svg":he,me=v.titleSeparator,ge=void 0===me?"out of":me,xe=v.SVGstyle,_e=v.SVGstorkeWidth,Ce=void 0===_e?0:_e,we=v.SVGstrokeColor,Ve=void 0===we?"currentColor":we,ke=t.useReducer(r,{hoverIndex:0,valueIndex:0,ratingValue:_,hoverValue:null}),Se=ke[0],be=Se.ratingValue,Me=Se.hoverValue,Ge=Se.hoverIndex,Ie=Se.valueIndex,Ne=ke[1];t.useEffect((function(){_&&Ne({type:"MouseClick",payload:0})}),[_]);var je=t.useMemo((function(){return P?2*w:w}),[P,w]),Pe=t.useMemo((function(){return _>je?0:P||Math.floor(_)===_?Math.round(_/w*100):2*Math.ceil(_)*10}),[P,_,w,je]),Ae=t.useMemo((function(){return(P?2*_-1:_-1)||0}),[P,_]),Le=t.useCallback((function(e){return w%2!=0?e/2/10:e*w/100}),[w]),Re=function(e){for(var t=e.clientX,o=e.currentTarget.children[0].getBoundingClientRect(),n=o.left,i=o.right,r=o.width,l=G?i-t:t-n,a=je,s=Math.round(r/je),c=0;c<=je;c+=1)if(l<=s*c){a=0===c&&l<s?0:c;break}var d=a-1;a>0&&(Ne({type:"PointerMove",payload:100*a/je,index:d}),y&&Me&&y(Le(Me),d,e))},Te=function(e){Me&&(Ne({type:"MouseClick",payload:Me}),h&&h(Le(Me),Ge,e))},We=t.useMemo((function(){if(B){if(F){var e=be&&be||Pe;return Me&&Me>e?Me:e}return Me&&Me||be&&be||Pe}return be&&be||Pe}),[B,F,Me,be,Pe]);t.useEffect((function(){ue.length>je&&console.error("tooltipArray Array length is bigger then Icons Count length.")}),[ue.length,je]);var ze=t.useCallback((function(e){return Me&&e[Ge]||be&&e[Ie]||_&&e[Ae]}),[Me,Ge,be,Ie,_,Ae]),Be=t.useMemo((function(){return Me&&Le(Me)||be&&Le(be)||_&&Le(Pe)}),[Me,Le,be,_,Pe]);return e.jsxs("span",o({className:l,style:{direction:"".concat(G?"rtl":"ltr")}},{children:[e.jsxs("span",o({className:"".concat(a," ").concat(R),style:o({cursor:b?"":"pointer"},A),onPointerMove:b?void 0:Re,onPointerEnter:b?void 0:function(e){m&&m(e),u()&&Re(e)},onPointerLeave:b?void 0:function(e){u()&&Te(),Ne({type:"PointerLeave"}),g&&g(e)},onClick:b?void 0:Te,"aria-hidden":"true"},{children:[e.jsx("span",o({className:"".concat(c," ").concat(ne),style:o({color:ee},te)},{children:n([],Array(w),!0).map((function(o,n){var r;return e.jsx(t.Fragment,{children:(null===(r=N[n])||void 0===r?void 0:r.icon)||Q||e.jsx(i,{SVGclassName:ye,SVGstyle:xe,SVGstorkeWidth:Ce,SVGstrokeColor:Ve,size:k})},n)}))})),e.jsx("span",o({className:"".concat(s," ").concat(X),style:o((p={},p[G?"right":"left"]=0,p.color=ze(U)||J,p.transition=W?"width .2s ease, color .2s ease":"",p.width="".concat(We,"%"),p),Z),title:re?"".concat(Be," ").concat(ge," ").concat(w):void 0},{children:n([],Array(w),!0).map((function(o,n){var r;return e.jsx(t.Fragment,{children:(null===(r=N[n])||void 0===r?void 0:r.icon)||O||e.jsx(i,{SVGclassName:ye,SVGstyle:xe,SVGstorkeWidth:Ce,SVGstrokeColor:Ve,size:k})},n)}))}))]})),ae&&e.jsx("span",o({className:"".concat(d," ").concat(fe),style:o((f={},f[G?"marginRight":"marginLeft"]=20,f),ve)},{children:(ue.length>0?ze(ue):Be)||ce}))]}))};
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 50549:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; },
/* harmony export */   "y": function() { return /* binding */ SkeletonTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';


/**
 * @internal
 */
const SkeletonThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, customHighlightBackground, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    if (typeof customHighlightBackground === 'string')
        style['--custom-highlight-background'] = customHighlightBackground;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: i },
                skeletonSpan,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null)));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}




/***/ })

}]);